webpackJsonp([2],{

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(693);
    var insertCss = __webpack_require__(33);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../node_modules/css-loader/index.js??ref--2-rules-3!../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../node_modules/sass-loader/lib/loader.js!./app.scss", function() {
        content = require("!!../../node_modules/css-loader/index.js??ref--2-rules-3!../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../node_modules/sass-loader/lib/loader.js!./app.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f4769f9b.eot";

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(772);
    var insertCss = __webpack_require__(33);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./Collapsible.scss", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./Collapsible.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(319);
module.exports = __webpack_require__(502);


/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./src/routes/error/ErrorPage.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ErrorPage_scss__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ErrorPage_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ErrorPage_scss__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */






var ErrorPage__ref = _jsx('div', {}, void 0, _jsx('h1', {}, void 0, 'Error'), _jsx('p', {}, void 0, 'Sorry, a critical error occurred on this page.'));

function ErrorPage(props) {
  if (false) {
    return _jsx('div', {}, void 0, _jsx('h1', {}, void 0, props.error.name), _jsx('pre', {}, void 0, props.error.stack));
  }

  return ErrorPage__ref;
}

ErrorPage.defaultProps = {
  error: null
};



/* harmony default export */ var ErrorPage_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__ErrorPage_scss___default.a)(ErrorPage));
// CONCATENATED MODULE: ./src/routes/home/messages.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(26);


var messages_messages = __WEBPACK_IMPORTED_MODULE_0_react_intl__["e" /* defineMessages */]({
  heading: {
    'id': 'home.heading',
    'defaultMessage': 'COME IN<br />\n      PLAY &<br />\n      GET SMART'
  },
  play: {
    'id': 'home.play',
    'defaultMessage': 'PLAY'
  },
  waltzingGames: {
    'id': 'home.waltzingGames',
    'defaultMessage': 'Waltzing Games'
  },
  andLearn: {
    'id': 'home.andLearn',
    'defaultMessage': 'And Learn'
  },
  getSmart: {
    'id': 'home.getSmart',
    'defaultMessage': 'GET SMART'
  },
  ourServices: {
    'id': 'home.ourServices',
    'defaultMessage': 'Our Services'
  },
  ourProducts: {
    'id': 'home.ourProducts',
    'defaultMessage': 'Our Products'
  },
  ourUsersSay: {
    'id': 'home.ourUsersSay',
    'defaultMessage': 'Our Users Say'
  },
  ourPartners: {
    'id': 'home.ourPartners',
    'defaultMessage': 'Our Partners & Customers'
  }
});

/* harmony default export */ var messages_defaultExport = (messages_messages);
// CONCATENATED MODULE: ./src/routes/time/messages.js
/* harmony import */ var messages___WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(26);


/* harmony default export */ var time_messages_defaultExport = (messages___WEBPACK_IMPORTED_MODULE_0_react_intl__["e" /* defineMessages */]({
  // About
  description: {
    'id': 'product.time.description',
    'defaultMessage': 'A web-based time tracking system'
  },

  // Payment
  monthlyPayment: {
    'id': 'product.time.feature.monthlyPayment',
    'defaultMessage': 'per month per user (net price)'
  },

  // Standard
  standard: {
    'id': 'product.time.feature.standard',
    'defaultMessage': 'Standard'
  },

  limitMessageStandard: {
    'id': 'product.time.feature.limitMessageStandard',
    'defaultMessage': '3 users minimum'
  },

  featureTrackTime: {
    'id': 'product.time.feature.featureTrackTime',
    'defaultMessage': 'Track your time and assign it to projects'
  },
  featureTrackHolidays: {
    'id': 'product.time.feature.featureTrackHolidays',
    'defaultMessage': 'Track holidays, vacancies and illness'
  },
  featureGitlab: {
    'id': 'product.time.feature.featureGitlab',
    'defaultMessage': 'Gitlab project support: sync your projects with your Gitlab'
  },
  featureGitlabIssue: {
    'id': 'product.time.feature.featureGitlabIssue',
    'defaultMessage': 'GitLab issue support: entries assigned to issues show up in your GitLab'
  },
  featureJira: {
    'id': 'product.time.feature.featureJira',
    'defaultMessage': 'Jira project support: sync your projects with your Jira'
  },
  featureLogins: {
    'id': 'product.time.feature.logins',
    'defaultMessage': 'Logins: Local Account, GitLab or Jira'
  },
  featureBillable: {
    'id': 'product.time.feature.billable',
    'defaultMessage': 'Projects can be billable or non-billable'
  },
  featureAdminSupervice: {
    'id': 'product.time.feature.adminSupervice',
    'defaultMessage': 'Admin mode: supervise your team hours'
  },
  featureAdminCustomProjects: {
    'id': 'product.time.feature.adminCustomProjects',
    'defaultMessage': 'Admin mode: create custom projects with categories'
  },
  featureAdminExport: {
    'id': 'product.time.feature.adminExport',
    'defaultMessage': 'Admin mode: export project hours as Pdf'
  },

  // Pro
  pro: {
    'id': 'product.time.feature.pro',
    'defaultMessage': 'Pro'
  },

  limitMessagePro: {
    'id': 'product.time.feature.limitMessagePro',
    'defaultMessage': '5 users minimum'
  },
  featureHeaderTextPro: {
    'id': 'product.time.feature.featureHeaderTextPro',
    'defaultMessage': 'All Standard features'
  },

  featureTeamControllingAll: {
    'id': 'product.time.feature.teamControllingAll',
    'defaultMessage': 'Team Controlling: see team hours and projects at one glance'
  },
  featureTeamControllingIndividual: {
    'id': 'product.time.feature.teamControllingIndividual',
    'defaultMessage': 'Team Controlling: see team member hours for any individual period'
  },
  featureShortWork: {
    'id': 'product.time.feature.featureShortWork',
    'defaultMessage': 'Short Work: create short work periods and assign users to every short work period'
  },
  featureShortWorkFilter: {
    'id': 'product.time.feature.featureShortWorkFilter',
    'defaultMessage': 'Short Work: every user can filter by the short work periods he is assigned to'
  },
  featureShortWorkExport: {
    'id': 'product.time.feature.featureShortWorkExport',
    'defaultMessage': 'Short Work: The spent hours can be exported per user of a short work period'
  },

  // On Premise
  onPremise: {
    'id': 'product.time.feature.onPremise',
    'defaultMessage': 'On Premise'
  },

  limitMessageOnPremise: {
    'id': 'product.time.feature.limitMessageOnPremise',
    'defaultMessage': '10 users minimum'
  },
  featureHeaderTextOnPremise: {
    'id': 'product.time.feature.featureHeaderTextOnPremise',
    'defaultMessage': 'All Pro features'
  },

  featureDockerized: {
    'id': 'product.time.feature.dockerized',
    'defaultMessage': 'Fully dockerized in-house setup'
  },
  featureTimeTrackingInHouse: {
    'id': 'product.time.feature.timeTrackingInHouse',
    'defaultMessage': 'All time tracking data stays in house'
  }
}));
// CONCATENATED MODULE: ./src/routes/license/messages.js
/* harmony import */ var license_messages___WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(26);


/* harmony default export */ var license_messages_defaultExport = (license_messages___WEBPACK_IMPORTED_MODULE_0_react_intl__["e" /* defineMessages */]({
  // About
  description: {
    'id': 'product.license.description',
    'defaultMessage': 'A web-based license-managing system'
  },

  // Payment
  monthlyPayment: {
    'id': 'product.license.feature.monthlyPayment',
    'defaultMessage': 'per month (net price)'
  },

  // Starter
  starter: {
    'id': 'product.license.feature.starter',
    'defaultMessage': 'Starter'
  },

  limitMessageStarter: {
    'id': 'product.license.feature.limitMessageStarter',
    'defaultMessage': '3 months minimum'
  },

  featureApiKeyStats: {
    'id': 'product.license.feature.apiKeyStats',
    'defaultMessage': 'See statistics on API keys (e.g. last validation call)'
  },
  featureDashboard: {
    'id': 'product.license.feature.dashboard',
    'defaultMessage': 'Dashboard with overview on your server API keys and your personal API keys'
  },
  featureProductDefinition: {
    'id': 'product.license.feature.productDefinition',
    'defaultMessage': 'Definition of products'
  },
  featureLicenseDefinition: {
    'id': 'product.license.feature.licenseDefinition',
    'defaultMessage': 'Definition of licenses: multiple licenses can be defined for one product'
  },
  featureManageCustomers: {
    'id': 'product.license.feature.manageCustomers',
    'defaultMessage': 'Manage customers and one billing data per customer'
  },
  featureApiKeyDefinition: {
    'id': 'product.license.feature.apiKeyDefinition',
    'defaultMessage': 'Definition of API keys'
  },
  featureApiKeyValidity: {
    'id': 'product.license.feature.apiKeyValidity',
    'defaultMessage': 'Specify validity intervals for API keys'
  },
  featureLimits: {
    'id': 'product.license.feature.limits',
    'defaultMessage': 'Define hard and soft limits for API key credits'
  },
  featureActiveApiKeys: {
    'id': 'product.license.feature.activeApiKeys',
    'defaultMessage': 'Up to 1000 active API keys'
  },
  featureRequestsPerMonth: {
    'id': 'product.license.feature.requestsPerMonth',
    'defaultMessage': 'Up to 100k requests per month'
  },

  // Business
  business: {
    'id': 'product.license.feature.business',
    'defaultMessage': 'Business'
  },

  limitMessageBusiness: {
    'id': 'product.license.feature.limitMessageBusiness',
    'defaultMessage': '6 months minimum'
  },
  featureHeaderTextBusiness: {
    'id': 'product.license.feature.headerTextBusiness',
    'defaultMessage': 'All Starter features'
  },

  featureUnlimitedApiKeys: {
    'id': 'product.license.feature.unlimitedApiKeys',
    'defaultMessage': 'Unlimited API keys'
  },
  featureProductVersionLifeTime: {
    'id': 'product.license.feature.productVersionLifeTime',
    'defaultMessage': 'Define life time of product versions'
  },
  featureMultipleProductsPerLicense: {
    'id': 'product.license.feature.multipleProductsPerLicense',
    'defaultMessage': 'Assign multiple products to one license'
  },
  featureEMailNotification: {
    'id': 'product.license.feature.eMailNotification',
    'defaultMessage': 'E-Mail notification (e.g. API key creation, expiring API keys)'
  },
  featureValidityAutoRenew: {
    'id': 'product.license.feature.validityAutoRenew',
    'defaultMessage': 'Auto-Renew feature of API key validities'
  },

  featureRequestPerMonthNote: {
    'id': 'product.license.feature.requestPerMonthNote',
    'defaultMessage': 'For more requests per month than the Starter pack, a personalized pricing needs to be arranged'
  },

  // On Premise
  onPremise: {
    'id': 'product.license.feature.onPremise',
    'defaultMessage': 'On Premise'
  },

  limitMessageOnPremise: {
    'id': 'product.license.feature.limitMessageOnPremise',
    'defaultMessage': '6 months minimum'
  },
  featureHeaderTextOnPremise: {
    'id': 'product.license.feature.featureHeaderTextOnPremise',
    'defaultMessage': 'All Business features'
  },

  featureDockerized: {
    'id': 'product.license.feature.dockerized',
    'defaultMessage': 'Fully dockerized in-house setup'
  },
  featureLicenseManagingInHouse: {
    'id': 'product.license.feature.licenseManagingInHouse',
    'defaultMessage': 'All license managing data stays in house'
  }
}));
// CONCATENATED MODULE: ./src/components/Navigation/messages.js
/* harmony import */ var Navigation_messages___WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(26);


var Navigation_messages_messages = Navigation_messages___WEBPACK_IMPORTED_MODULE_0_react_intl__["e" /* defineMessages */]({
  brandName: {
    'id': 'navigation.brandName',
    'defaultMessage': 'waltzing'
  },
  additionalMenuItems: {
    'id': 'navigation.additionalMenuItems',
    'defaultMessage': 'More ...'
  },
  play: {
    'id': 'navigation.play',
    'defaultMessage': 'Play'
  },
  services: {
    'id': 'navigation.services',
    'defaultMessage': 'Services'
  },
  products: {
    'id': 'navigation.products',
    'defaultMessage': 'Products'
  },
  aboutUs: {
    'id': 'navigation.aboutUs',
    'defaultMessage': 'About Us'
  },
  careers: {
    'id': 'navigation.careers',
    'defaultMessage': 'Careers'
  },
  contactUs: {
    'id': 'navigation.contactUs',
    'defaultMessage': 'Contact Us'
  },
  imprint: {
    'id': 'navigation.imprint',
    'defaultMessage': 'Imprint'
  },
  learning: {
    'id': 'navigation.learning',
    'defaultMessage': 'Learning'
  },
  help: {
    'id': 'navigation.help',
    'defaultMessage': 'Help & Tutorials'
  },
  forum: {
    'id': 'navigation.forum',
    'defaultMessage': 'Forum'
  }
});

/* harmony default export */ var Navigation_messages_defaultExport = (Navigation_messages_messages);
// CONCATENATED MODULE: ./src/constants/index.js
/* eslint-disable import/prefer-default-export */

var SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';
var SET_LOCALE_START = 'SET_LOCALE_START';
var SET_LOCALE_SUCCESS = 'SET_LOCALE_SUCCESS';
var SET_LOCALE_ERROR = 'SET_LOCALE_ERROR';
var SET_USER_DATA = 'SET_USER_DATA';
// CONCATENATED MODULE: ./src/actions/intl.js
/* harmony import */ var intl___WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intl_graphql__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intl_graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__intl_graphql__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable import/prefer-default-export */







function getIntlFromState(state) {
  var intl = state && state.intl || {};
  var initialNow = intl.initialNow,
      locale = intl.locale,
      messages = intl.messages;

  var localeMessages = messages && messages[locale] || {};
  var provider = new intl___WEBPACK_IMPORTED_MODULE_0_react_intl__["c" /* IntlProvider */]({
    initialNow: initialNow,
    locale: locale,
    messages: localeMessages,
    defaultLocale: 'en-US'
  });
  return provider.getChildContext().intl;
}

function getIntl() {
  return function (dispatch, getState) {
    return getIntlFromState(getState());
  };
}

function setLocale(_ref) {
  var _this = this;

  var locale = _ref.locale;

  return function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState, _ref3) {
      var client = _ref3.client;

      var _ref4, data, messages, maxAge;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: SET_LOCALE_START,
                payload: {
                  locale: locale
                }
              });

              _context.prev = 1;
              _context.next = 4;
              return client.networkInterface.query({
                query: __WEBPACK_IMPORTED_MODULE_2__intl_graphql___default.a,
                variables: { locale: locale }
              });

            case 4:
              _ref4 = _context.sent;
              data = _ref4.data;
              messages = data.intl.reduce(function (msgs, msg) {
                msgs[msg.id] = msg.message; // eslint-disable-line no-param-reassign
                return msgs;
              }, {});

              dispatch({
                type: SET_LOCALE_SUCCESS,
                payload: {
                  locale: locale,
                  messages: messages
                }
              });

              // remember locale for every new request
              if (true) {
                maxAge = 3650 * 24 * 3600; // 10 years in seconds

                document.cookie = 'lang=' + locale + ';path=/;max-age=' + maxAge;
              }

              // return bound intl instance at the end
              return _context.abrupt('return', getIntlFromState(getState()));

            case 12:
              _context.prev = 12;
              _context.t0 = _context['catch'](1);

              dispatch({
                type: SET_LOCALE_ERROR,
                payload: {
                  locale: locale,
                  error: _context.t0
                }
              });
              return _context.abrupt('return', null);

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 12]]);
    }));

    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
}
// CONCATENATED MODULE: ./src/components/LanguageSwitcher/LanguageSwitcher.js
/* harmony import */ var LanguageSwitcher___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var LanguageSwitcher___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(LanguageSwitcher___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var LanguageSwitcher___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var LanguageSwitcher___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(LanguageSwitcher___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LanguageSwitcher_scss__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LanguageSwitcher_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LanguageSwitcher_scss__);
var LanguageSwitcher__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/* eslint-disable no-shadow */








function LanguageSwitcher(_ref) {
  var currentLocale = _ref.currentLocale,
      availableLocales = _ref.availableLocales,
      setLocale = _ref.setLocale;

  var isSelected = function isSelected(locale) {
    return locale === currentLocale;
  };
  var localeDict = {
    /* @intl-code-template '${lang}-${COUNTRY}': '${Name}', */
    'en-US': 'EN',
    'de-DE': 'DE'
    /* @intl-code-template-end */
  };
  var localeName = function localeName(locale) {
    return localeDict[locale] || locale;
  };
  return LanguageSwitcher__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__LanguageSwitcher_scss___default.a.languageSwitcher
  }, void 0, availableLocales.map(function (locale) {
    return LanguageSwitcher__jsx('span', {}, locale, isSelected(locale) ? LanguageSwitcher__jsx('span', {}, void 0, localeName(locale)) : // github.com/yannickcr/eslint-plugin-react/issues/945
    // eslint-disable-next-line react/jsx-indent
    LanguageSwitcher__jsx('a', {
      href: '?lang=' + locale,
      onClick: function onClick(e) {
        setLocale({ locale: locale });
        e.preventDefault();
      }
    }, void 0, localeName(locale)), ' ');
  }));
}

var mapState = function mapState(state) {
  return {
    availableLocales: state.runtime.availableLocales,
    currentLocale: state.intl.locale
  };
};

var mapDispatch = {
  setLocale: setLocale
};

/* harmony default export */ var LanguageSwitcher_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */](mapState, mapDispatch)(__WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__LanguageSwitcher_scss___default.a)(LanguageSwitcher)));
// CONCATENATED MODULE: ./src/components/Navigation/Navigation.js
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Navigation___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var Navigation___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Navigation___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logo_svg__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__logo_svg__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Navigation__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();













var scrollOptions = {
  spy: true,
  smooth: true,
  duration: 500,
  role: 'button'
};

// eslint-disable-next-line react/prop-types
var ScrollNavItem = function ScrollNavItem(_ref) {
  var children = _ref.children;
  return Navigation__jsx('li', {
    role: 'presentation'
  }, void 0, children);
};

var Navigation__ref2 = Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* Navbar */].Toggle, {});

var Navigation__ref3 = Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["d" /* Glyphicon */], {
  glyph: 'menu-hamburger'
});

var Navigation__ref4 = Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* MenuItem */], {
  eventKey: 3.2,
  href: '/time',
  target: '_self',
  rel: 'noopener noreferrer'
}, void 0, 'Waltzing Time');

var _ref5 = Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* MenuItem */], {
  eventKey: 3.3,
  href: '/license',
  target: '_self',
  rel: 'noopener noreferrer'
}, void 0, 'Waltzing License');

var _ref6 = Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* MenuItem */], {
  eventKey: 3.4,
  href: 'https://www.danube.ai/',
  target: '_blank',
  rel: 'noopener noreferrer'
}, void 0, 'danube.ai');

var _ref7 = Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* MenuItem */], {
  eventKey: 3.4,
  href: 'http://www.waltzingatoms.com',
  target: '_blank',
  rel: 'noopener noreferrer'
}, void 0, 'Waltzing Atoms');

var _ref8 = Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* MenuItem */], {
  eventKey: 3.4,
  href: 'http://creativity.waltzing.at',
  target: '_blank',
  rel: 'noopener noreferrer'
}, void 0, 'Waltzing Creativity');

var _ref9 = Navigation__jsx(LanguageSwitcher_defaultExport, {});

function Navigation(props) {
  var intl = props.intl,
      pathname = props.location.pathname;

  var isMainPage = pathname === '/';

  var topLink = isMainPage ? Navigation___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_scroll__["Link"],
    _extends({}, scrollOptions, { to: 'top' }),
    Navigation__jsx('img', {
      src: __WEBPACK_IMPORTED_MODULE_8__logo_svg___default.a,
      alt: intl.formatMessage(Navigation_messages_defaultExport.brandName)
    })
  ) : Navigation__jsx(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["b" /* Link */], {
    to: '/'
  }, void 0, Navigation__jsx('img', {
    src: __WEBPACK_IMPORTED_MODULE_8__logo_svg___default.a,
    alt: intl.formatMessage(Navigation_messages_defaultExport.brandName)
  }));
  return Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* Navbar */], {
    className: 'top-nav',
    collapseOnSelect: true,
    fluid: true,
    fixedTop: true
  }, void 0, Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* Navbar */].Header, {}, void 0, Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* Navbar */].Brand, {}, void 0, topLink), Navigation__ref2), Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["h" /* Navbar */].Collapse, {}, void 0, Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* Nav */], {
    pullRight: true
  }, void 0, Navigation__jsx(ScrollNavItem, {}, void 0, isMainPage && Navigation___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_scroll__["Link"],
    _extends({}, scrollOptions, { to: 'getSmart' }),
    Navigation___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* FormattedMessage */], Navigation_messages_defaultExport.products)
  )), Navigation__jsx(ScrollNavItem, {}, void 0, isMainPage && Navigation___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_2_react_scroll__["Link"],
    _extends({}, scrollOptions, { to: 'services' }),
    Navigation___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* FormattedMessage */], Navigation_messages_defaultExport.services)
  )), Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* NavDropdown */], {
    eventKey: 3,
    title: Navigation__ref3,
    id: 'top-nav-dropdown'
  }, void 0, Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* MenuItem */], {
    eventKey: 3.1,
    href: 'http://www.waltzingatoms.com/motivation',
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, Navigation___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* FormattedMessage */], Navigation_messages_defaultExport.aboutUs)), Navigation__ref4, _ref5, _ref6, _ref7, _ref8, Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* MenuItem */], {
    eventKey: 3.5,
    href: 'http://www.waltzingatoms.com/career',
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, Navigation___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* FormattedMessage */], Navigation_messages_defaultExport.careers)), Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* MenuItem */], {
    eventKey: 3.6,
    href: 'mailto:office@3datax.com'
  }, void 0, Navigation___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* FormattedMessage */], Navigation_messages_defaultExport.contactUs)), Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* MenuItem */], {
    eventKey: 3.7,
    href: 'http://www.waltzingatoms.com/3datax',
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, Navigation___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* FormattedMessage */], Navigation_messages_defaultExport.imprint)), Navigation__jsx(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* MenuItem */], {
    eventKey: 3.8,
    href: 'https://forum.waltzingatoms.com/',
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, Navigation___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_intl__["b" /* FormattedMessage */], Navigation_messages_defaultExport.forum)), _ref9))));
}

/* harmony default export */ var Navigation_defaultExport = (__WEBPACK_IMPORTED_MODULE_5_react_router__["d" /* withRouter */](__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* injectIntl */](Navigation)));
// CONCATENATED MODULE: ./src/components/Header/Header.js
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var Header___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Header___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header_scss__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Header_scss__);
var Header__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var Header__ref = Header__jsx('div', {}, void 0, Header__jsx(Navigation_defaultExport, {}));

function Header(props) {
  return Header__ref;
}

/* harmony default export */ var Header_defaultExport = (__WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_2__Header_scss___default.a)(Header));
// CONCATENATED MODULE: ./src/components/Footer/Footer.js
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var Footer___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Footer___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_icons_lib_fa_facebook__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_icons_lib_fa_facebook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_icons_lib_fa_facebook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_icons_lib_fa_twitter__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_icons_lib_fa_twitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_icons_lib_fa_twitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_linkedin__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_linkedin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_linkedin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_xing__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_xing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_xing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_medium__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_medium___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_medium__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_icons_lib_fa_instagram__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_icons_lib_fa_instagram___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_icons_lib_fa_instagram__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Footer_scss__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Footer_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Footer_scss__);
var Footer__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Footer__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/* eslint-disable react/no-array-index-key */













var Footer_messages = __WEBPACK_IMPORTED_MODULE_1_react_intl__["e" /* defineMessages */]({
  ourCompany: {
    'id': 'footer.ourCompany',
    'defaultMessage': 'Our Company'
  },
  ourProducts: {
    'id': 'footer.ourProducts',
    'defaultMessage': 'Our Products'
  },
  getSmart: {
    'id': 'footer.getSmart',
    'defaultMessage': 'Get Smart'
  },
  copyright: {
    'id': 'footer.copyright',
    'defaultMessage': 'All rights reserved &copy; {year} Waltzing'
  }
});

var blocks = [{
  id: 'ourCompany',
  name: Footer___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], Footer_messages.ourCompany),
  items: [{
    link: Footer__jsx('a', {
      href: 'http://www.waltzingatoms.com/motivation',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, void 0, Footer___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], Navigation_messages_defaultExport.aboutUs))
  }, {
    link: Footer__jsx('a', {
      href: 'http://www.waltzingatoms.com/career',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, void 0, Footer___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], Navigation_messages_defaultExport.careers))
  }, {
    link: Footer__jsx('a', {
      href: 'mailto:office@waltzing.at'
    }, void 0, Footer___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], Navigation_messages_defaultExport.contactUs))
  }, {
    link: Footer__jsx('a', {
      href: 'http://www.waltzingatoms.com/3datax',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, void 0, Footer___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], Navigation_messages_defaultExport.imprint))
  }]
}, {
  id: 'ourProducts',
  name: Footer___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], Footer_messages.ourProducts),
  items: [{
    link: Footer__jsx('a', {
      href: '/time',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, void 0, 'Waltzing Time')
  }, {
    link: Footer__jsx('a', {
      href: '/license',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, void 0, 'Waltzing License')
  }, {
    link: Footer__jsx('a', {
      href: 'https://www.danube.ai/',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, void 0, 'danube.ai')
  }, {
    link: Footer__jsx('a', {
      href: 'http://www.waltzingatoms.com',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, void 0, 'Waltzing Atoms')
  }, {
    link: Footer__jsx('a', {
      href: 'http://creativity.waltzing.at',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, void 0, 'Waltzing Creativity')
  }]
}];

var Footer__ref = Footer__jsx('a', {
  href: 'https://www.facebook.com/waltzing.at',
  target: '_blank',
  rel: 'noopener noreferrer'
}, void 0, Footer__jsx(__WEBPACK_IMPORTED_MODULE_2_react_icons_lib_fa_facebook___default.a, {}));

var Footer__ref2 = Footer__jsx('a', {
  href: 'https://twitter.com/waltzing_at',
  target: '_blank',
  rel: 'noopener noreferrer'
}, void 0, Footer__jsx(__WEBPACK_IMPORTED_MODULE_3_react_icons_lib_fa_twitter___default.a, {}));

var Footer__ref3 = Footer__jsx('a', {
  href: 'https://instagram.com/waltzing.at',
  target: '_blank',
  rel: 'noopener noreferrer'
}, void 0, Footer__jsx(__WEBPACK_IMPORTED_MODULE_7_react_icons_lib_fa_instagram___default.a, {}));

var Footer__ref4 = Footer__jsx('a', {
  href: 'https://www.linkedin.com/company/waltzing/',
  target: '_blank',
  rel: 'noopener noreferrer'
}, void 0, Footer__jsx(__WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_linkedin___default.a, {}));

var Footer__ref5 = Footer__jsx('a', {
  href: 'https://www.xing.com/companies/3dataxgmbh%26cokg',
  target: '_blank',
  rel: 'noopener noreferrer'
}, void 0, Footer__jsx(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_xing___default.a, {}));

var Footer__ref6 = Footer__jsx('a', {
  href: 'https://medium.com/breaking-pad/',
  target: '_blank',
  rel: 'noopener noreferrer'
}, void 0, Footer__jsx(__WEBPACK_IMPORTED_MODULE_6_react_icons_lib_fa_medium___default.a, {}));

function Footer(props) {
  return Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_scss___default.a.footer + ' row'
  }, void 0, Footer__jsx('div', {
    className: 'col-xs-12'
  }, void 0, Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_scss___default.a.content + ' row'
  }, void 0, blocks.map(function (block) {
    return Footer__jsx('div', {
      className: 'col-sm-4 col-xs-12'
    }, block.id, Footer__jsx('h4', {}, void 0, block.name), Footer__jsx('ul', {}, void 0, block.items.map(function (item, index) {
      return Footer__jsx('li', {}, index, item.link);
    })));
  }), Footer__jsx('div', {
    className: 'col-sm-4 col-xs-12'
  }, void 0, Footer__jsx('h4', {}, void 0, Footer___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], Footer_messages.getSmart)), Footer__jsx('ul', {}, void 0, Footer__jsx('li', {}, void 0, Footer__jsx('a', {
    href: 'http://forum.waltzingatoms.com',
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, Footer___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], Navigation_messages_defaultExport.forum)), Footer__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_9__Footer_scss___default.a.socialMediaLinks
  }, void 0, Footer__ref, Footer__ref2, Footer__ref3, Footer__ref4, Footer__ref5, Footer__ref6)))), Footer__jsx('div', {
    className: 'col-xs-12 small',
    style: {
      marginTop: '25px'
    }
  }, void 0, Footer___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_intl__["a" /* FormattedHTMLMessage */], Footer__extends({}, Footer_messages.copyright, {
    values: {
      year: new Date().getFullYear()
    }
  }))))));
}

/* harmony default export */ var Footer_defaultExport = (__WEBPACK_IMPORTED_MODULE_8_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_9__Footer_scss___default.a)(Footer));
// CONCATENATED MODULE: ./src/components/Sidebar/Sidebar.js
/* harmony import */ var Sidebar___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var Sidebar___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Sidebar___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Sidebar___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(31);
/* harmony import */ var Sidebar___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Sidebar___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_scss__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Sidebar_scss__);
var Sidebar__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var Sidebar__ref = Sidebar__jsx('span', {}, void 0, 'gamify everything');

function Sidebar(props) {
  return Sidebar__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2__Sidebar_scss___default.a.sidebar
  }, void 0, Sidebar__ref);
}

/* harmony default export */ var Sidebar_defaultExport = (Sidebar___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_2__Sidebar_scss___default.a)(Sidebar));
// CONCATENATED MODULE: ./src/components/Layout/Layout.js
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_2_react_scroll__ = __webpack_require__(207);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_2_react_scroll___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_2_react_scroll__);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(31);
/* harmony import */ var Layout___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Layout___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_app_scss__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_app_scss__);
var Layout__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();











var Layout__ref = Layout__jsx(Layout___WEBPACK_IMPORTED_MODULE_2_react_scroll__["Element"], {
  name: 'top'
});

var Layout__ref2 = Layout__jsx(Header_defaultExport, {});

var Layout__ref3 = Layout__jsx(Sidebar_defaultExport, {});

var Layout__ref4 = Layout__jsx(Footer_defaultExport, {});

function Layout(props) {
  return Layout__jsx('div', {
    className: 'container-fluid root-container'
  }, void 0, Layout__jsx('div', {
    className: 'content'
  }, void 0, Layout__jsx('div', {
    className: 'row'
  }, void 0, Layout__jsx('div', {
    className: 'col-xs-12'
  }, void 0, Layout__ref, Layout__ref2, props.children, Layout__ref3))), Layout__ref4);
}

/* harmony default export */ var Layout_defaultExport = (Layout___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__styles_app_scss___default.a)(Layout));
// CONCATENATED MODULE: ./src/routes/home/products/Products.js
/* harmony import */ var Products___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var Products___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Products___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Products___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var Products___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Products___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(26);
/* harmony import */ var Products___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(31);
/* harmony import */ var Products___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Products___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Products_scss__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Products_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Products_scss__);
var Products__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var Products_Products = function (_React$Component) {
  _inherits(Products, _React$Component);

  function Products(props) {
    _classCallCheck(this, Products);

    var _this = _possibleConstructorReturn(this, (Products.__proto__ || Object.getPrototypeOf(Products)).call(this, props));

    _this.renderProducts = _this.renderProducts.bind(_this);
    _this.renderProductRow = _this.renderProductRow.bind(_this);
    return _this;
  }

  _createClass(Products, [{
    key: 'renderProducts',
    value: function renderProducts() {
      // group into pairs of three
      // pairs get rendered in a new row each
      var products = this.props.products;

      var productRows = products.reduce(function (result, value, index, array) {
        if (index % 3 === 0) result.push(array.slice(index, index + 3));
        return result;
      }, []);

      return productRows.map(this.renderProductRow);
    }
  }, {
    key: 'renderProductRow',
    value: function renderProductRow(productRow, index) {
      var className = [__WEBPACK_IMPORTED_MODULE_4__Products_scss___default.a.products, this.props.className].join(' ');

      var dataset1 = productRow[0];
      var dataset2 = productRow[1];
      var dataset3 = productRow[2];

      var content = function content(product) {
        var waltzingTitleStyle = product.waltzingTitle ? {} : { visibility: 'hidden' };
        return Products__jsx('div', {
          className: 'col-sm-4 col-xs-12 ' + __WEBPACK_IMPORTED_MODULE_4__Products_scss___default.a.product
        }, product.name, Products__jsx('img', {
          src: product.logo,
          alt: product.name,
          style: { height: '80px', width: '80px' },
          className: 'img-responsive'
        }), Products__jsx('h3', {
          className: 'teal',
          style: waltzingTitleStyle
        }, void 0, 'Waltzing'), Products__jsx('h3', {}, void 0, product.name), Products__jsx('h4', {}, void 0, product.heading), Products__jsx('p', {
          style: { minHeight: '70px' }
        }, void 0, product.description), product.link && Products__jsx('a', {
          href: product.link,
          target: '' + (product.openNewPage ? '_blank' : '_self'),
          rel: 'noopener noreferrer',
          className: 'btn btn-teal btn--small'
        }, void 0, product.linkLabel));
      };
      return Products__jsx('div', {
        className: 'row ' + className
      }, 'product-row-' + index, content(dataset1), dataset2 && content(dataset2) /* second value of row can be empty */, dataset3 && content(dataset3) /* third value of row can be empty */);
    }
  }, {
    key: 'render',
    value: function render() {
      var heading = this.props.heading;


      return Products__jsx('div', {}, void 0, Products__jsx('h2', {}, void 0, Products___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], messages_defaultExport.getSmart)), Products__jsx('h3', {}, void 0, heading), this.renderProducts());
    }
  }]);

  return Products;
}(Products___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Products_Products.defaultProps = {
  heading: Products___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], messages_defaultExport.ourProducts),
  className: ''
};


/* harmony default export */ var Products_defaultExport = (Products___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__Products_scss___default.a)(Products_Products));
// CONCATENATED MODULE: ./src/routes/home/customers/Customers.js
/* harmony import */ var Customers___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var Customers___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Customers___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Customers___WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(26);
/* harmony import */ var Customers___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(31);
/* harmony import */ var Customers___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Customers___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Customers_scss__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Customers_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Customers_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bmb_jpg__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bmb_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__bmb_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bitmedia_jpg__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bitmedia_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__bitmedia_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fcio_jpg__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fcio_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__fcio_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__talentify_jpg__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__talentify_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__talentify_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tu_png__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tu_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__tu_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mavoco_jpg__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mavoco_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__mavoco_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__arbeiterkammer_jpg__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__arbeiterkammer_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__arbeiterkammer_jpg__);
var Customers__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Customers__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };















var testimonialMessages = Customers___WEBPACK_IMPORTED_MODULE_1_react_intl__["e" /* defineMessages */]({
  student: {
    'id': 'testimonials.student',
    'defaultMessage': '{name}, Student from Vienna'
  },
  teacher: {
    'id': 'testimonials.teacher',
    'defaultMessage': '{name}, Teacher from Vienna'
  },
  student1: {
    'id': 'testimonials.student1',
    'defaultMessage': 'The app is great and very informative.'
  },
  student2: {
    'id': 'testimonials.student2',
    'defaultMessage': 'The app is pretty cool. Could change chemistry lessons\n      once and for all.'
  },
  teacher1: {
    'id': 'testimonials.teacher1',
    'defaultMessage': 'Binding structures and their changes can be\n      explained more clearly than anywhere else.'
  }
});

var testimonials = [{
  key: 1,
  user: Customers___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Customers___WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], Customers__extends({}, testimonialMessages.student, {
    values: { name: 'Lisa' }
  })),
  testimonial: Customers___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Customers___WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], testimonialMessages.student1)
}, {
  key: 2,
  user: Customers___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Customers___WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], Customers__extends({}, testimonialMessages.student, {
    values: { name: 'David' }
  })),
  testimonial: Customers___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Customers___WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], testimonialMessages.student2)
}, {
  key: 3,
  user: Customers___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Customers___WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], Customers__extends({}, testimonialMessages.teacher, {
    values: { name: 'Wolfgang' }
  })),
  testimonial: Customers___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Customers___WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], testimonialMessages.teacher1)
}];

/* eslint-disable prettier/prettier */
var partners = [{ name: 'FCIO', logo: __WEBPACK_IMPORTED_MODULE_7__fcio_jpg___default.a, link: 'http://www.fcio.at/Default.aspx?site=fcio.at-DE' }, { name: 'Bitmedia', logo: __WEBPACK_IMPORTED_MODULE_6__bitmedia_jpg___default.a, link: 'https://www.bitmedia.at/en/' }, { name: 'Bundesministerium für Bildung', logo: __WEBPACK_IMPORTED_MODULE_5__bmb_jpg___default.a, link: 'https://www.bmb.gv.at/' }, { name: 'talentify', logo: __WEBPACK_IMPORTED_MODULE_8__talentify_jpg___default.a, link: 'https://www.talentify.me/' }, { name: 'Technical University of Vienna', logo: __WEBPACK_IMPORTED_MODULE_9__tu_png___default.a, link: 'https://www.tuwien.ac.at/en/' }, { name: 'Mavoco', logo: __WEBPACK_IMPORTED_MODULE_10__mavoco_jpg___default.a, link: 'http://www.mavoco.com/' }, { name: 'AK', logo: __WEBPACK_IMPORTED_MODULE_11__arbeiterkammer_jpg___default.a, link: 'https://wien.arbeiterkammer.at/beratung/bildung/schule/AK-App_Jopsy.html' }];
/* eslint-enable prettier/prettier */

function Customers(props) {
  return Customers__jsx('div', {}, void 0, Customers__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__Customers_scss___default.a.container
  }, void 0, Customers__jsx('h3', {}, void 0, Customers___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Customers___WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], messages_defaultExport.ourUsersSay)), Customers__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__Customers_scss___default.a.testimonials + ' row'
  }, void 0, testimonials.map(function (testimonial, index) {
    return Customers__jsx('div', {
      className: '\n                  ' + __WEBPACK_IMPORTED_MODULE_3__Customers_scss___default.a.testimonial + '\n                  ' + (index % 2 !== 0 ? __WEBPACK_IMPORTED_MODULE_3__Customers_scss___default.a.testimonialInverse : null) + '\n                  col-sm-4 col-xs-12\n                '
    }, testimonial.key, Customers__jsx('div', {}, void 0, Customers__jsx('p', {}, void 0, testimonial.testimonial), Customers__jsx('span', {}, void 0, testimonial.user)));
  }))), Customers__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__Customers_scss___default.a.partners
  }, void 0, Customers__jsx('h3', {}, void 0, Customers___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Customers___WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], messages_defaultExport.ourPartners)), partners.map(function (partner) {
    return Customers__jsx('a', {
      href: partner.link,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, partner.name, Customers__jsx('img', {
      src: partner.logo,
      alt: partner.name
    }));
  })));
}

/* harmony default export */ var Customers_defaultExport = (Customers___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_3__Customers_scss___default.a)(Customers));
// CONCATENATED MODULE: ./src/routes/home/Home.js
/* harmony import */ var Home___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var Home___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Home___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_document_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_document_title__);
/* harmony import */ var Home___WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Home_scss__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Home_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Home_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__products_atoms_svg__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__products_atoms_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__products_atoms_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__products_creativity_svg__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__products_creativity_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__products_creativity_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__products_fishy_blue_svg__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__products_fishy_blue_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__products_fishy_blue_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__products_training_svg__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__products_training_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__products_training_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__products_recruiting_svg__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__products_recruiting_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__products_recruiting_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__products_custom_svg__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__products_custom_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__products_custom_svg__);
var Home__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





















var serviceMessages = Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* defineMessages */]({
  waltzingTraining: {
    'id': 'services.waltzingTraining',
    'defaultMessage': 'Get Smart in Training'
  },
  waltzingTrainingDescription: {
    'id': 'services.waltzingTrainingDescription',
    'defaultMessage': 'Training doesn\'t need to be hard - learn new\n      skills through a playful experience'
  },
  waltzingRecruiting: {
    'id': 'services.waltzingRecruiting',
    'defaultMessage': 'Get Smart in Recruiting'
  },
  waltzingRecruitingDescription: {
    'id': 'services.waltzingRecruitingDescription',
    'defaultMessage': 'Find not only better but fitting candidates for your\n      open positions by the means of playing'
  },
  waltzingCustom: {
    'id': 'services.waltzingCustom',
    'defaultMessage': 'Get Smart in Everything'
  },
  waltzingCustomDescription: {
    'id': 'services.waltzingCustomDescription',
    'defaultMessage': 'We gamify everything - get in touch with us\n      and we will provide you with a tailor-made,\n      playful solution'
  },
  linkLabel: {
    'id': 'services.linkLabel',
    'defaultMessage': 'Contact Us'
  }
});

/* eslint-disable prettier/prettier */
var services = [{
  name: 'Training',
  logo: __WEBPACK_IMPORTED_MODULE_15__products_training_svg___default.a,
  color: 'grey',
  heading: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], serviceMessages.waltzingTraining),
  description: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], serviceMessages.waltzingTrainingDescription),
  link: 'mailto:sales@waltzing.at',
  linkLabel: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], serviceMessages.linkLabel)
}, {
  name: 'Recruiting',
  logo: __WEBPACK_IMPORTED_MODULE_16__products_recruiting_svg___default.a,
  color: 'grey',
  heading: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], serviceMessages.waltzingRecruiting),
  description: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], serviceMessages.waltzingRecruitingDescription),
  link: 'mailto:sales@waltzing.at',
  linkLabel: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], serviceMessages.linkLabel)
}, {
  name: 'Custom',
  logo: __WEBPACK_IMPORTED_MODULE_17__products_custom_svg___default.a,
  color: 'grey',
  heading: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], serviceMessages.waltzingCustom),
  description: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], serviceMessages.waltzingCustomDescription),
  link: 'mailto:sales@waltzing.at',
  linkLabel: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], serviceMessages.linkLabel)
}];
/* eslint-enable prettier/prettier */

var productMessages = Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["e" /* defineMessages */]({
  waltzingAtoms: {
    'id': 'products.waltzingAtoms',
    'defaultMessage': 'Smart Chemistry'
  },
  waltzingAtomsDescription: {
    'id': 'products.waltzingAtomsDescription',
    'defaultMessage': 'Playfully learn chemistry with breath-taking chemical reactions and\n      structures in 3D'
  },
  waltzingCreativity: {
    'id': 'products.waltzingCreativity',
    'defaultMessage': 'Smart Creativity'
  },
  waltzingCreativityDescription: {
    'id': 'products.waltzingCreativityDescription',
    'defaultMessage': 'Playfully experience and develop your creative skills\n      through relaxing and intuitive gameplay'
  },
  danube: {
    'id': 'products.danube',
    'defaultMessage': 'Smart AI'
  },
  danubeDescription: {
    'id': 'products.danubeDescription',
    'defaultMessage': 'Stop fishing for data in the dark.\n      With danube, you\u2019ll catch the right fish.'
  },
  time: {
    'id': 'products.time',
    'defaultMessage': 'Smart Time Tracking'
  },
  license: {
    'id': 'products.license',
    'defaultMessage': 'Smart License Management'
  },
  linkLabel: {
    'id': 'products.linkLabel',
    'defaultMessage': 'GO GET IT'
  },
  comingSoon: {
    'id': 'products.comingSoon',
    'defaultMessage': 'COMING SOON'
  },
  learnMore: {
    'id': 'products.learnMore',
    'defaultMessage': 'LEARN MORE'
  }
});

/* eslint-disable prettier/prettier */
var products = [{
  name: 'Time',
  waltzingTitle: true,
  logo: "/product/time.svg",
  color: 'green',
  heading: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], productMessages.time),
  description: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], time_messages_defaultExport.description),
  link: '/time',
  linkLabel: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], productMessages.learnMore),
  openNewPage: false
}, {
  name: 'License',
  waltzingTitle: true,
  logo: "/product/license.svg",
  color: 'purple',
  heading: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], productMessages.license),
  description: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], license_messages_defaultExport.description),
  link: '/license',
  linkLabel: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], productMessages.learnMore),
  openNewPage: false
}, {
  name: 'danube.ai',
  logo: __WEBPACK_IMPORTED_MODULE_14__products_fishy_blue_svg___default.a,
  color: 'blue',
  heading: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], productMessages.danube),
  description: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], productMessages.danubeDescription),
  link: 'https://www.danube.ai',
  linkLabel: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], productMessages.learnMore),
  openNewPage: true
}, {
  name: 'Atoms',
  waltzingTitle: true,
  logo: __WEBPACK_IMPORTED_MODULE_12__products_atoms_svg___default.a,
  color: 'green',
  heading: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], productMessages.waltzingAtoms),
  description: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], productMessages.waltzingAtomsDescription),
  link: 'http://www.waltzingatoms.com',
  linkLabel: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], productMessages.learnMore),
  openNewPage: true
}, {
  name: 'Creativity',
  waltzingTitle: true,
  logo: __WEBPACK_IMPORTED_MODULE_13__products_creativity_svg___default.a,
  color: 'purple',
  heading: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], productMessages.waltzingCreativity),
  description: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], productMessages.waltzingCreativityDescription),
  link: 'http://creativity.waltzing.at',
  linkLabel: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], productMessages.learnMore),
  openNewPage: true
}];
/* eslint-enable prettier/prettier */

var Home__ref = Home__jsx(__WEBPACK_IMPORTED_MODULE_3_react_scroll__["Element"], {
  name: 'getSmart'
}, void 0, Home__jsx(Products_defaultExport, {
  products: products
}));

var Home__ref2 = Home__jsx(Customers_defaultExport, {});

function Home(props) {
  return Home__jsx(__WEBPACK_IMPORTED_MODULE_1_react_document_title___default.a, {
    title: 'Waltzing'
  }, void 0, Home__jsx(Layout_defaultExport, {}, void 0, Home__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__Home_scss___default.a.container
  }, void 0, Home__jsx(__WEBPACK_IMPORTED_MODULE_3_react_scroll__["Element"], {
    name: 'home'
  }, void 0, Home__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__Home_scss___default.a.section
  }, void 0, Home__jsx('h1', {}, void 0, Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["a" /* FormattedHTMLMessage */], messages_defaultExport.heading)), Home__jsx('img', {
    src: '/header.jpg',
    alt: 'Waltzing',
    className: 'img-responsive ' + __WEBPACK_IMPORTED_MODULE_5__Home_scss___default.a.contentImage
  }))), Home__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__Home_scss___default.a.section
  }, void 0, Home__ref, Home__jsx(__WEBPACK_IMPORTED_MODULE_3_react_scroll__["Element"], {
    name: 'services'
  }, void 0, Home__jsx(Products_defaultExport, {
    products: services,
    heading: Home___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Home___WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], messages_defaultExport.ourServices),
    className: __WEBPACK_IMPORTED_MODULE_5__Home_scss___default.a.services
  })), Home__ref2))));
}

/* harmony default export */ var Home_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_5__Home_scss___default.a)(Home));
// CONCATENATED MODULE: ./src/components/Collapsible/index.js
/* harmony import */ var Collapsible___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var Collapsible___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Collapsible___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(210);
/* harmony import */ var Collapsible___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(31);
/* harmony import */ var Collapsible___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Collapsible___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Collapsible_scss__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Collapsible_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Collapsible_scss__);
var Collapsible__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Collapsible__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Collapsible__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Collapsible__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Collapsible__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// eslint-disable-next-line css-modules/no-unused-class


var Collapsible = function (_React$Component) {
  Collapsible__inherits(Collapsible, _React$Component);

  function Collapsible(props) {
    Collapsible__classCallCheck(this, Collapsible);

    var _this = Collapsible__possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).call(this, props));

    _this.state = {
      open: _this.props.open
    };

    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  Collapsible__createClass(Collapsible, [{
    key: 'toggle',
    value: function toggle() {
      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return Collapsible__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a('panel', __WEBPACK_IMPORTED_MODULE_4__Collapsible_scss___default.a.panel)
      }, void 0, Collapsible__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a('panel-heading', __WEBPACK_IMPORTED_MODULE_4__Collapsible_scss___default.a.panelHeading)
      }, void 0, Collapsible__jsx(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */], {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a('btn', __WEBPACK_IMPORTED_MODULE_4__Collapsible_scss___default.a.toggleButton),
        onClick: function onClick() {
          return _this2.toggle();
        }
      }, void 0, this.state.open && this.props.headingWhenOpened ? this.props.headingWhenOpened : this.props.heading, Collapsible__jsx('i', {
        className: this.state.open ? 'fa fa-caret-up' : 'fa fa-caret-down'
      }))), Collapsible__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default.a('panel-body', __WEBPACK_IMPORTED_MODULE_4__Collapsible_scss___default.a.panelBody)
      }, void 0, Collapsible__jsx(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["c" /* Collapse */], {
        'in': this.state.open
      }, void 0, this.props.children)));
    }
  }]);

  return Collapsible;
}(Collapsible___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Collapsible.defaultProps = {
  open: false,
  headingWhenOpened: undefined
};


/* harmony default export */ var Collapsible_defaultExport = (Collapsible___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_4__Collapsible_scss___default.a)(Collapsible));
// CONCATENATED MODULE: ./src/components/ProductPage/Features/index.js
/* harmony import */ var Features___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var Features___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Features___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Features___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var Features___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Features___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var Features___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(31);
/* harmony import */ var Features___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Features___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_check__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_check___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_check__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_asterisk__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_asterisk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_asterisk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Features_scss__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Features_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Features_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Collapsible_Collapsible_scss__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Collapsible_Collapsible_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Collapsible_Collapsible_scss__);
var Features__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Features__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Features__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Features__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Features__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/forbid-prop-types */
/* eslint-disable css-modules/no-unused-class */












var Features_messages = __WEBPACK_IMPORTED_MODULE_6_react_intl__["e" /* defineMessages */]({
  showDetails: {
    'id': 'pricing.showDetails',
    'defaultMessage': 'Show details'
  },
  hideDetails: {
    'id': 'pricing.hideDetails',
    'defaultMessage': 'Hide details'
  }
});

var Features__ref = Features__jsx('i', {}, void 0, Features__jsx(__WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_check___default.a, {}));

var Features__ref2 = Features__jsx('li', {});

var Features__ref3 = Features__jsx('i', {}, void 0, Features__jsx(__WEBPACK_IMPORTED_MODULE_4_react_icons_lib_fa_check___default.a, {}));

var Features__ref4 = Features__jsx('i', {}, void 0, Features__jsx(__WEBPACK_IMPORTED_MODULE_5_react_icons_lib_fa_asterisk___default.a, {}));

var Features_Features = function (_React$Component) {
  Features__inherits(Features, _React$Component);

  function Features(props) {
    Features__classCallCheck(this, Features);

    var _this = Features__possibleConstructorReturn(this, (Features.__proto__ || Object.getPrototypeOf(Features)).call(this, props));

    _this.renderFeature = _this.renderFeature.bind(_this);
    _this.renderFeatureHeaderText = _this.renderFeatureHeaderText.bind(_this);
    return _this;
  }

  Features__createClass(Features, [{
    key: 'renderFeatureHeaderText',
    value: function renderFeatureHeaderText() {
      var featureHeaderText = this.props.featureHeaderText;


      if (featureHeaderText) {
        return Features__jsx('li', {}, featureHeaderText.id, Features__ref, Features__jsx('strong', {
          style: { fontSize: '1rem' }
        }, void 0, Features___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["b" /* FormattedMessage */], featureHeaderText)));
      }
      return Features__ref2;
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'renderFeature',
    value: function renderFeature(feature) {
      return Features__jsx('li', {}, feature.id, Features__ref3, Features___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["b" /* FormattedMessage */], feature));
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'renderNote',
    value: function renderNote(note) {
      return Features__jsx('li', {}, note.id, Features__ref4, Features___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_intl__["b" /* FormattedMessage */], note));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          featureList = _props.featureList,
          notesList = _props.notesList,
          collapsible = _props.collapsible;

      var renderedFeatures = featureList.map(this.renderFeature);
      var renderedNotes = notesList ? notesList.map(this.renderNote) : null;

      if (collapsible) {
        return Features__jsx('div', {
          className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a('visible-xs', __WEBPACK_IMPORTED_MODULE_9__Collapsible_Collapsible_scss___default.a.collapsibleDetails)
        }, void 0, Features__jsx(Collapsible_defaultExport, {
          heading: this.props.intl.formatMessage(Features_messages.showDetails),
          headingWhenOpened: this.props.intl.formatMessage(Features_messages.hideDetails)
        }, void 0, Features__jsx('ul', {
          className: __WEBPACK_IMPORTED_MODULE_8__Features_scss___default.a.licenseBenefits
        }, void 0, this.renderFeatureHeaderText(this.props.featureHeaderText), renderedFeatures, renderedNotes)));
      }

      return Features__jsx('ul', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default.a('hidden-xs', __WEBPACK_IMPORTED_MODULE_8__Features_scss___default.a.licenseBenefits)
      }, void 0, this.renderFeatureHeaderText(), renderedFeatures, renderedNotes);
    }
  }]);

  return Features;
}(Features___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Features_Features.defaultProps = {
  collapsible: false,
  featureHeaderText: null,
  notesList: null
};


/* harmony default export */ var Features_defaultExport = (__WEBPACK_IMPORTED_MODULE_6_react_intl__["f" /* injectIntl */](Features___WEBPACK_IMPORTED_MODULE_3_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_8__Features_scss___default.a, __WEBPACK_IMPORTED_MODULE_9__Collapsible_Collapsible_scss___default.a)(Features_Features)));
// CONCATENATED MODULE: ./src/components/ProductPage/Pricing/index.js
/* harmony import */ var Pricing___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var Pricing___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(Pricing___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var Pricing___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var Pricing___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(Pricing___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var Pricing___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(31);
/* harmony import */ var Pricing___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(Pricing___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Pricing_scss__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Pricing_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Pricing_scss__);
var Pricing__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var Pricing__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function Pricing__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Pricing__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Pricing__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/no-unused-prop-types */









var Pricing_messages = __WEBPACK_IMPORTED_MODULE_3_react_intl__["e" /* defineMessages */]({
  header: {
    'id': 'product.pricing.header',
    'defaultMessage': 'Pricing Overview'
  },
  buyNow: {
    'id': 'product.pricing.buyNow',
    'defaultMessage': 'GO GET IT'
  }
});

var Pricing_Pricing = function (_React$Component) {
  Pricing__inherits(Pricing, _React$Component);

  function Pricing(props) {
    Pricing__classCallCheck(this, Pricing);

    var _this = Pricing__possibleConstructorReturn(this, (Pricing.__proto__ || Object.getPrototypeOf(Pricing)).call(this, props));

    _this.renderPricing = _this.renderPricing.bind(_this);
    return _this;
  }

  // eslint-disable-next-line class-methods-use-this


  Pricing__createClass(Pricing, [{
    key: 'renderPricing',
    value: function renderPricing(pricing, index) {
      var pricingCount = this.props.pricing.length;
      var title = pricing.title,
          limitMessage = pricing.limitMessage,
          featureHeaderText = pricing.featureHeaderText,
          featureList = pricing.featureList,
          notesList = pricing.notesList,
          buyLink = pricing.buyLink;

      var bootstrapSize = pricingCount > 0 ? 12 / pricingCount : 1;
      return Pricing__jsx(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["b" /* Col */], {
        xs: 12,
        sm: bootstrapSize
      }, 'pricing-' + index, Pricing__jsx('h4', {}, void 0, Pricing___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */], title)), Pricing__jsx('span', {
        className: __WEBPACK_IMPORTED_MODULE_6__Pricing_scss___default.a.price
      }, void 0, limitMessage && Pricing__jsx('span', {
        className: 'small semi-light-grey'
      }, void 0, Pricing___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */], limitMessage)), !limitMessage && Pricing__jsx('span', {
        className: 'small semi-light-grey',
        style: { visibility: 'hidden' }
      }, void 0, 'No limit')), Pricing__jsx(Features_defaultExport, {
        featureHeaderText: featureHeaderText,
        featureList: featureList,
        notesList: notesList,
        collapsible: true
      }), Pricing__jsx('a', {
        href: buyLink,
        target: '_blank',
        rel: 'noopener noreferrer',
        className: 'btn btn-teal btn--small'
      }, void 0, Pricing___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */], Pricing_messages.buyNow)), Pricing__jsx(Features_defaultExport, {
        featureHeaderText: featureHeaderText,
        featureList: featureList,
        notesList: notesList
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var pricing = this.props.pricing;

      return Pricing__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_6__Pricing_scss___default.a.pricingContainer
      }, void 0, Pricing__jsx('h3', {}, void 0, Pricing___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_intl__["b" /* FormattedMessage */], Pricing_messages.header)), Pricing__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_6__Pricing_scss___default.a.pricingContentContainer
      }, void 0, Pricing__jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_6__Pricing_scss___default.a.content
      }, void 0, Pricing__jsx(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["i" /* Row */], {
        className: __WEBPACK_IMPORTED_MODULE_6__Pricing_scss___default.a.licenses
      }, void 0, pricing.map(this.renderPricing)))));
    }
  }]);

  return Pricing;
}(Pricing___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Pricing_Pricing.defaultProps = {
  limitMessage: null,
  notesList: null
};


/* harmony default export */ var Pricing_defaultExport = (Pricing___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_6__Pricing_scss___default.a)(Pricing_Pricing));
// CONCATENATED MODULE: ./src/components/ProductPage/index.js
/* harmony import */ var ProductPage___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var ProductPage___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ProductPage___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ProductPage___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var ProductPage___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ProductPage___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var ProductPage___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(31);
/* harmony import */ var ProductPage___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(ProductPage___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var ProductPage___WEBPACK_IMPORTED_MODULE_4__styles_app_scss__ = __webpack_require__(296);
/* harmony import */ var ProductPage___WEBPACK_IMPORTED_MODULE_4__styles_app_scss___default = __webpack_require__.n(ProductPage___WEBPACK_IMPORTED_MODULE_4__styles_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductPage_scss__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProductPage_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ProductPage_scss__);
var ProductPage__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();









function ProductPage(props) {
  var headerImg = props.headerImg,
      logoImg = props.logoImg,
      productName = props.productName,
      productDescription = props.productDescription;

  return ProductPage__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__ProductPage_scss___default.a.container
  }, void 0, ProductPage__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__ProductPage_scss___default.a.header
  }, void 0, ProductPage__jsx('img', {
    className: __WEBPACK_IMPORTED_MODULE_5__ProductPage_scss___default.a.logoImg,
    src: logoImg,
    alt: ''
  }), ProductPage__jsx('h1', {}, void 0, productName)), ProductPage__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_5__ProductPage_scss___default.a.subline
  }, void 0, ProductPage__jsx('h2', {}, void 0, productDescription)), ProductPage__jsx('img', {
    className: __WEBPACK_IMPORTED_MODULE_5__ProductPage_scss___default.a.headerImg,
    src: headerImg,
    alt: ''
  }), ProductPage__jsx(Pricing_defaultExport, {
    pricing: props.pricing
  }));
}

ProductPage.defaultProps = {
  tagline: '',
  pricing: []
};


/* harmony default export */ var ProductPage_defaultExport = (ProductPage___WEBPACK_IMPORTED_MODULE_2_isomorphic_style_loader_lib_withStyles___default.a(ProductPage___WEBPACK_IMPORTED_MODULE_4__styles_app_scss___default.a, __WEBPACK_IMPORTED_MODULE_5__ProductPage_scss___default.a)(ProductPage));
// CONCATENATED MODULE: ./src/routes/time/index.js
/* harmony import */ var time___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var time___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(time___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var time___WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(26);
var time__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








var time_pricing = [{
  title: time_messages_defaultExport.standard,
  monthlyPrice: 4,
  monthlyPayment: time_messages_defaultExport.monthlyPayment,
  limitMessage: time_messages_defaultExport.limitMessageStandard,
  featureList: [time_messages_defaultExport.featureTrackTime, time_messages_defaultExport.featureTrackHolidays, time_messages_defaultExport.featureGitlab, time_messages_defaultExport.featureGitlabIssue, time_messages_defaultExport.featureJira, time_messages_defaultExport.featureLogins, time_messages_defaultExport.featureBillable, time_messages_defaultExport.featureAdminSupervice, time_messages_defaultExport.featureAdminCustomProjects, time_messages_defaultExport.featureAdminExport],
  buyLink: 'mailto:sales@waltzing.at'
}, {
  title: time_messages_defaultExport.pro,
  monthlyPrice: 7,
  monthlyPayment: time_messages_defaultExport.monthlyPayment,
  limitMessage: time_messages_defaultExport.limitMessagePro,
  featureList: [time_messages_defaultExport.featureTeamControllingAll, time_messages_defaultExport.featureTeamControllingIndividual, time_messages_defaultExport.featureShortWork, time_messages_defaultExport.featureShortWorkFilter, time_messages_defaultExport.featureShortWorkExport],
  featureHeaderText: time_messages_defaultExport.featureHeaderTextPro,
  buyLink: 'mailto:sales@waltzing.at'
}, {
  title: time_messages_defaultExport.onPremise,
  monthlyPrice: 7,
  monthlyPayment: time_messages_defaultExport.monthlyPayment,
  limitMessage: time_messages_defaultExport.limitMessageOnPremise,
  featureList: [time_messages_defaultExport.featureDockerized, time_messages_defaultExport.featureTimeTrackingInHouse],
  featureHeaderText: time_messages_defaultExport.featureHeaderTextOnPremise,
  buyLink: 'mailto:sales@waltzing.at'
}];

function Time(props) {
  return time__jsx(Layout_defaultExport, {}, void 0, time__jsx(ProductPage_defaultExport, {
    headerImg: '/product/Waltzing-Time-Mockup_low-quality.jpg',
    logoImg: '/product/time.svg',
    productName: 'Waltzing Time',
    productDescription: time___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(time___WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], time_messages_defaultExport.description),
    pricing: time_pricing
  }));
}

/* harmony default export */ var time_defaultExport = (Time);
// CONCATENATED MODULE: ./src/routes/license/index.js
/* harmony import */ var license___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var license___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(license___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var license___WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(26);
var license__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








var license_pricing = [{
  title: license_messages_defaultExport.starter,
  monthlyPrice: 29,
  monthlyPayment: license_messages_defaultExport.monthlyPayment,
  limitMessage: license_messages_defaultExport.limitMessageStarter,
  featureList: [license_messages_defaultExport.featureApiKeyStats, license_messages_defaultExport.featureDashboard, license_messages_defaultExport.featureProductDefinition, license_messages_defaultExport.featureLicenseDefinition, license_messages_defaultExport.featureManageCustomers, license_messages_defaultExport.featureApiKeyDefinition, license_messages_defaultExport.featureApiKeyValidity, license_messages_defaultExport.featureLimits, license_messages_defaultExport.featureActiveApiKeys, license_messages_defaultExport.featureRequestsPerMonth],
  buyLink: 'mailto:sales@waltzing.at'
}, {
  title: license_messages_defaultExport.business,
  monthlyPrice: license__jsx('span', {}, void 0, '79', license__jsx('b', {}, void 0, '*')),
  monthlyPayment: license_messages_defaultExport.monthlyPayment,
  limitMessage: license_messages_defaultExport.limitMessageBusiness,
  featureList: [license_messages_defaultExport.featureUnlimitedApiKeys, license_messages_defaultExport.featureProductVersionLifeTime, license_messages_defaultExport.featureMultipleProductsPerLicense, license_messages_defaultExport.featureEMailNotification, license_messages_defaultExport.featureValidityAutoRenew],
  notesList: [license_messages_defaultExport.featureRequestPerMonthNote],
  featureHeaderText: license_messages_defaultExport.featureHeaderTextBusiness,
  buyLink: 'mailto:sales@waltzing.at'
}, {
  title: license_messages_defaultExport.onPremise,
  monthlyPrice: 79,
  monthlyPayment: license_messages_defaultExport.monthlyPayment,
  limitMessage: license_messages_defaultExport.limitMessageOnPremise,
  featureList: [license_messages_defaultExport.featureDockerized, license_messages_defaultExport.featureLicenseManagingInHouse],
  featureHeaderText: license_messages_defaultExport.featureHeaderTextOnPremise,
  buyLink: 'mailto:sales@waltzing.at'
}];

function license_Time(props) {
  return license__jsx(Layout_defaultExport, {}, void 0, license__jsx(ProductPage_defaultExport, {
    headerImg: '/product/Waltzing-License-Mockup_low-quality.jpg',
    logoImg: '/product/license.svg',
    productName: 'Waltzing License',
    productDescription: license___WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(license___WEBPACK_IMPORTED_MODULE_1_react_intl__["b" /* FormattedMessage */], license_messages_defaultExport.description),
    pricing: license_pricing
  }));
}

/* harmony default export */ var license_defaultExport = (license_Time);
// CONCATENATED MODULE: ./src/routes/index.js





var routes = [{
  path: '/',
  component: Home_defaultExport,
  exact: true
}, {
  path: '/time',
  component: time_defaultExport,
  exact: true
}, {
  path: '/license',
  component: license_defaultExport,
  exact: true
}, {
  path: '/error',
  component: ErrorPage_defaultExport,
  exact: true
}];

/* harmony default export */ var routes_defaultExport = (routes);
// CONCATENATED MODULE: ./src/routes/notFound/NotFound.js
/* harmony import */ var NotFound___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var NotFound___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(NotFound___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var NotFound___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__ = __webpack_require__(31);
/* harmony import */ var NotFound___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default = __webpack_require__.n(NotFound___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotFound_scss__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NotFound_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__NotFound_scss__);
var NotFound__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







var NotFound__ref = NotFound__jsx('h1', {}, void 0, '404');

var NotFound__ref2 = NotFound__jsx('p', {}, void 0, 'Sorry, the page you were trying to view does not exist.');

function NotFound(props) {
  return NotFound__jsx(Layout_defaultExport, {}, void 0, NotFound__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2__NotFound_scss___default.a.root
  }, void 0, NotFound__jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_2__NotFound_scss___default.a.container
  }, void 0, NotFound__ref, NotFound__ref2)));
}

/* harmony default export */ var NotFound_defaultExport = (NotFound___WEBPACK_IMPORTED_MODULE_1_isomorphic_style_loader_lib_withStyles___default.a(__WEBPACK_IMPORTED_MODULE_2__NotFound_scss___default.a)(NotFound));
// CONCATENATED MODULE: ./src/components/ScrollToTop/ScrollToTop.js
/* harmony import */ var ScrollToTop___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var ScrollToTop___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(ScrollToTop___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var ScrollToTop___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var ScrollToTop___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(ScrollToTop___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(25);
var ScrollToTop__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function ScrollToTop__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ScrollToTop__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ScrollToTop__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Scrolls to the top of a page once its rendered.
 * This is useful for navigation purposes, where you generally want
 * to start on the top of the page you're navigating though.
 *
 * Doesn't jump to the top when hitting the browser's back button,
 * which is desired behaviour since you usually want to end up
 * exactly where you were (including scroll position) if you
 * click back.
 */





var ScrollToTop = function (_React$Component) {
  ScrollToTop__inherits(ScrollToTop, _React$Component);

  function ScrollToTop() {
    ScrollToTop__classCallCheck(this, ScrollToTop);

    return ScrollToTop__possibleConstructorReturn(this, (ScrollToTop.__proto__ || Object.getPrototypeOf(ScrollToTop)).apply(this, arguments));
  }

  ScrollToTop__createClass(ScrollToTop, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return ScrollToTop;
}(ScrollToTop___WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ var ScrollToTop_defaultExport = (__WEBPACK_IMPORTED_MODULE_2_react_router__["d" /* withRouter */](ScrollToTop));
// CONCATENATED MODULE: ./src/components/RouteBundler/RouteBundler.js
/* harmony import */ var RouteBundler___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var RouteBundler___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(RouteBundler___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(187);
var RouteBundler__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();








var RouteBundler__ref = RouteBundler__jsx(NotFound_defaultExport, {});

function RouteBundler(props) {
  return RouteBundler__jsx(ScrollToTop_defaultExport, {}, void 0, RouteBundler__jsx(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Switch */], {}, void 0, routes_defaultExport.map(function (route) {
    return RouteBundler__jsx(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */], {
      path: route.path,
      component: route.component,
      exact: route.exact
    }, route.path);
  }), RouteBundler__ref));
}

/* harmony default export */ var RouteBundler_defaultExport = (__WEBPACK_IMPORTED_MODULE_1_react_router__["d" /* withRouter */](RouteBundler));
// CONCATENATED MODULE: ./src/components/App.js
/* harmony import */ var App___WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var App___WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(App___WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var App___WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var App___WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(App___WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var App___WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router__ = __webpack_require__(25);
var App__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var App__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var App__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function App__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function App__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function App__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */









var ContextType = App__extends({
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: App___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  // Universal HTTP client
  fetch: App___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
}, __WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */].childContextTypes, {
  // Apollo Client
  client: App___WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  // ReactIntl
  intl: App___WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* IntlProvider */].childContextTypes.intl
});

/**
 * The top-level React component setting context (global) variables
 * that can be accessed from all the child components.
 *
 * https://facebook.github.io/react/docs/context.html
 *
 * Usage example:
 *
 *   const context = {
 *     history: createBrowserHistory(),
 *     store: createStore(),
 *   };
 *
 *   ReactDOM.render(
 *     <App context={context}>
 *       <Layout>
 *         <LandingPage />
 *       </Layout>
 *     </App>,
 *     container,
 *   );
 */

var App__ref = App__jsx(RouteBundler_defaultExport, {});

var App = function (_React$PureComponent) {
  App__inherits(App, _React$PureComponent);

  function App() {
    App__classCallCheck(this, App);

    return App__possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  App__createClass(App, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return this.props.context;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var store = this.props.context && this.props.context.store;
      if (store) {
        this.lastLocale = store.getState().intl.locale;
        this.unsubscribe = store.subscribe(function () {
          var state = store.getState();
          var _state$intl = state.intl,
              newLocale = _state$intl.newLocale,
              locale = _state$intl.locale;

          if (!newLocale && _this2.lastLocale !== locale) {
            _this2.lastLocale = locale;
            _this2.forceUpdate();
          }
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var store = this.props.context && this.props.context.store;
      var state = store && store.getState();
      this.intl = state && state.intl || {};
      var _intl = this.intl,
          initialNow = _intl.initialNow,
          locale = _intl.locale,
          messages = _intl.messages;

      var localeMessages = messages && messages[locale] || {};
      return App__jsx(App___WEBPACK_IMPORTED_MODULE_2_react_intl__["c" /* IntlProvider */], {
        initialNow: initialNow,
        locale: locale,
        messages: localeMessages,
        defaultLocale: 'en-US',
        location: this.props.location
      }, void 0, App__ref);
    }
  }]);

  return App;
}(App___WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

App.childContextTypes = ContextType;


/* harmony default export */ var App_defaultExport = (__WEBPACK_IMPORTED_MODULE_4_react_router__["d" /* withRouter */](App));
// CONCATENATED MODULE: ./src/createFetch.js
var createFetch__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Creates a wrapper function around the HTML5 Fetch API that provides
 * default arguments to fetch(...) and is intended to reduce the amount
 * of boilerplate code in the application.
 * https://developer.mozilla.org/docs/Web/API/Fetch_API/Using_Fetch
 */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

function createFetch(fetch, _ref) {
  var baseUrl = _ref.baseUrl,
      cookie = _ref.cookie;

  // NOTE: Tweak the default options to suite your application needs
  var defaults = {
    method: 'POST', // handy with GraphQL backends
    mode: baseUrl ? 'cors' : 'same-origin',
    credentials: baseUrl ? 'include' : 'same-origin',
    headers: createFetch__extends({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }, cookie ? { Cookie: cookie } : null)
  };

  return function (url, options) {
    return url.startsWith('/graphql') || url.startsWith('/api') ? fetch('' + baseUrl + url, createFetch__extends({}, defaults, options, {
      headers: createFetch__extends({}, defaults.headers, options && options.headers)
    })) : fetch(url, options);
  };
}

/* harmony default export */ var createFetch_defaultExport = (createFetch);
// CONCATENATED MODULE: ./src/reducers/user.js
var user__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { username: 'something' };
  var action = arguments[1];

  switch (action.type) {
    case SET_USER_DATA:
      return user__extends({}, state, {
        username: action.payload.username
      });
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/runtime.js
var runtime__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function runtime() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case SET_RUNTIME_VARIABLE:
      return runtime__extends({}, state, _defineProperty({}, action.payload.name, action.payload.value));
    default:
      return state;
  }
}
// CONCATENATED MODULE: ./src/reducers/intl.js
var intl__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function intl__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



function intl_intl() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  if (state === null) {
    return {
      initialNow: Date.now()
    };
  }

  switch (action.type) {
    case SET_LOCALE_START:
      {
        var locale = state[action.payload.locale] ? action.payload.locale : state.locale;
        return intl__extends({}, state, {
          locale: locale,
          newLocale: action.payload.locale
        });
      }

    case SET_LOCALE_SUCCESS:
      {
        return intl__extends({}, state, {
          locale: action.payload.locale,
          newLocale: null,
          messages: intl__extends({}, state.messages, intl__defineProperty({}, action.payload.locale, action.payload.messages))
        });
      }

    case SET_LOCALE_ERROR:
      {
        return intl__extends({}, state, {
          newLocale: null
        });
      }

    default:
      {
        return state;
      }
  }
}
// CONCATENATED MODULE: ./src/reducers/index.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(130);





function createRootReducer(_ref) {
  var apolloClient = _ref.apolloClient;

  return __WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */]({
    apollo: apolloClient.reducer(),
    user: user,
    runtime: runtime,
    intl: intl_intl
  });
}
// CONCATENATED MODULE: ./src/store/createHelpers.js
function createHelpers__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var graphqlRequestDeprecatedMessage = '`graphqlRequest` has been deprecated.\nYou should use Apollo: `client.query({ query, variables...})` or `client.mutate()`\nDon\'t forget to enclose your query to gql`\u2026` tag or import *.graphql file.\nSee docs at http://dev.apollodata.com/core/apollo-client-api.html#ApolloClient\\.query';

function createGraphqlRequest(apolloClient) {
  return function () {
    var _ref = createHelpers__asyncToGenerator(regeneratorRuntime.mark(function _callee(queryOrString, variables) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var skipCache, query, gql, isMutation;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (false) {
                // eslint-disable-next-line no-console
                console.error(graphqlRequestDeprecatedMessage);
              }

              skipCache = options.skipCache;
              query = queryOrString;

              if (!(typeof queryOrString === 'string')) {
                _context.next = 8;
                break;
              }

              _context.next = 6;
              return __webpack_require__.e/* require.ensure */(0).then((function (require) {
                return __webpack_require__(803);
              }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

            case 6:
              gql = _context.sent;

              query = gql([queryOrString]);

            case 8:
              if (!skipCache) {
                _context.next = 10;
                break;
              }

              return _context.abrupt('return', apolloClient.networkInterface.query({ query: query, variables: variables }));

            case 10:
              isMutation = false;

              if (query.definitions) {
                isMutation = query.definitions.some(function (definition) {
                  return definition && definition.operation === 'mutation';
                });
              }

              if (!isMutation) {
                _context.next = 14;
                break;
              }

              return _context.abrupt('return', apolloClient.mutate({ mutation: query, variables: variables }));

            case 14:
              return _context.abrupt('return', apolloClient.query({ query: query, variables: variables }));

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function graphqlRequest(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return graphqlRequest;
  }();
}

function createHelpers(_ref2) {
  var apolloClient = _ref2.apolloClient,
      fetch = _ref2.fetch,
      history = _ref2.history;

  return {
    client: apolloClient,
    history: history,
    fetch: fetch,
    // @deprecated('Use `client` instead')
    apolloClient: apolloClient,
    // @deprecated('Use `client.query()` or `client.mutate()` instead')
    graphqlRequest: createGraphqlRequest(fetch)
  };
}
// CONCATENATED MODULE: ./src/store/logger/logger.client.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_logger__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_logger__);


function logger_client_createLogger() {
  return __WEBPACK_IMPORTED_MODULE_0_redux_logger__["createLogger"]({
    collapsed: true
  });
}
// CONCATENATED MODULE: ./src/store/configureStore.js
/* harmony import */ var configureStore___WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__);






function configureStore(initialState, config) {
  var helpers = createHelpers(config);
  var apolloClient = config.apolloClient;


  var middleware = [__WEBPACK_IMPORTED_MODULE_1_redux_thunk___default.a.withExtraArgument(helpers), apolloClient.middleware()];

  var enhancer = void 0;

  if (false) {
    middleware.push(createLogger());

    // https://github.com/zalmoxisus/redux-devtools-extension#redux-devtools-extension
    var devToolsExtension = function devToolsExtension(f) {
      return f;
    };
    if (process.env.BROWSER && window.devToolsExtension) {
      devToolsExtension = window.devToolsExtension();
    }

    enhancer = compose(applyMiddleware.apply(undefined, middleware), devToolsExtension);
  } else {
    enhancer = configureStore___WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */].apply(undefined, middleware);
  }

  var rootReducer = createRootReducer({
    apolloClient: apolloClient
  });

  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  var store = configureStore___WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */](rootReducer, initialState, enhancer);

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (false) {
    module.hot.accept('../reducers', function () {
      return (
        // Don't forget to remove `()` if you change reducers back to normal rootReducer.
        // eslint-disable-next-line global-require
        store.replaceReducer(require('../reducers').default({ apolloClient: apolloClient }))
      );
    });
  }

  return store;
}
// CONCATENATED MODULE: ./src/core/createApolloClient/createApolloClient.client.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_client__ = __webpack_require__(783);


var createApolloClient_client_client = new __WEBPACK_IMPORTED_MODULE_0_apollo_client__["b" /* default */]({
  networkInterface: __WEBPACK_IMPORTED_MODULE_0_apollo_client__["a" /* createNetworkInterface */]({
    uri: '/graphql',
    opts: {
      // Additional fetch options like `credentials` or `headers`
      credentials: 'include'
    }
  }),
  queryDeduplication: true,
  reduxRootSelector: function reduxRootSelector(state) {
    return state.apollo;
  }
});

function createApolloClient() {
  return createApolloClient_client_client;
}
// CONCATENATED MODULE: ./src/client.js
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_hot_loader__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_hot_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_hot_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_en__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl_locale_data_de__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl_locale_data_de___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_intl_locale_data_de__);
var client__jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */







// This is so bad: requiring all locale if they are not needed?
/* @intl-code-template import ${lang} from 'react-intl/locale-data/${lang}'; */


/* @intl-code-template-end */






var client_apolloClient = createApolloClient();

/* @intl-code-template addLocaleData(${lang}); */
__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* addLocaleData */](__WEBPACK_IMPORTED_MODULE_6_react_intl_locale_data_en___default.a);
__WEBPACK_IMPORTED_MODULE_5_react_intl__["d" /* addLocaleData */](__WEBPACK_IMPORTED_MODULE_7_react_intl_locale_data_de___default.a);
/* @intl-code-template-end */

/* eslint-disable global-require */

// Universal HTTP client
var fetch = createFetch_defaultExport(self.fetch, {
  baseUrl: window.App.apiUrl
});

// Initialize a new Redux store
// http://redux.js.org/docs/basics/UsageWithReact.html
var client_store = configureStore(window.App.state, {
  apolloClient: client_apolloClient,
  fetch: fetch
});

// Global (context) variables that can be easily accessed from any React component
// https://facebook.github.io/react/docs/context.html
var context = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: function insertCss() {
    for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
      styles[_key] = arguments[_key];
    }

    // eslint-disable-next-line no-underscore-dangle
    var removeCss = styles.map(function (x) {
      return x._insertCss();
    });
    return function () {
      removeCss.forEach(function (f) {
        return f();
      });
    };
  },
  // For react-apollo
  client: client_apolloClient,
  store: client_store,
  storeSubscription: null,
  // Universal HTTP client
  fetch: fetch,
  // intl instance as it can be get with injectIntl
  intl: client_store.dispatch(getIntl())
};

var container = document.getElementById('app');

var client__ref = client__jsx(__WEBPACK_IMPORTED_MODULE_4_react_hot_loader__["AppContainer"], {}, void 0, client__jsx(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* BrowserRouter */], {}, void 0, client__jsx(App_defaultExport, {
  context: context
})));

var client_render = function render() {
  __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(client__ref, container);
};

function main() {
  client_render();
}

// globally accesible entry point
window.RSK_ENTRY = main;

// Enable Hot Module Replacement (HMR)
if (false) {
  module.hot.accept('./components/App', function () {
    client_render();
  });
}
// CONCATENATED MODULE: ./src/clientLoader.js
/* WEBPACK VAR INJECTION */(function(global) {// polyfills


function run() {
  // Run the application when both DOM is ready and page content is loaded
  if (['complete', 'loaded', 'interactive'].includes(document.readyState) && document.body) {
    main();
  } else {
    document.addEventListener('DOMContentLoaded', main, false);
  }
}

if (!global.Intl) {
  // You can show loading banner here

  __webpack_require__.e/* require.ensure */(1).then((function (require) {
    // and require them here
    __webpack_require__(804);
    // TODO: This is bad. You should only require one language dynamically
    /* @intl-code-template require('intl/locale-data/jsonp/${lang}.js'); */
    __webpack_require__(805);
    __webpack_require__(806);
    /* @intl-code-template-end */
    run();
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
} else {
  run();
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(67)))

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 614:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 621:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(671);
    var insertCss = __webpack_require__(33);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./ErrorPage.scss", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./ErrorPage.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)(false);
// imports


// module
exports.push([module.i, "html{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;padding:0 32px;padding:0 2rem;height:100%;font-family:sans-serif;text-align:center;color:#888}body{margin:0}h1{font-weight:400;color:#555}pre{white-space:pre-wrap;text-align:left}", ""]);

// exports


/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(692);
    var insertCss = __webpack_require__(33);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./Home.scss", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./Home.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)(false);
// imports


// module
exports.push([module.i, "._2ABq6{position:relative;margin:0 auto;padding:0 15px;max-width:1000px}._2ABq6 h1,._2ABq6 h2,._2ABq6 h3{text-align:center}._2ABq6 h1{margin-bottom:50px}._2ABq6 h2{margin-bottom:0}._2ABq6 h3{margin-top:10px}@media (min-width:992px){._1wdVL{min-height:calc(100vh - 50px)}}._4VQaZ{margin:50px 0 75px}._3rEyO{padding-top:25px;padding-bottom:25px;background:#ccf8ef}", ""]);

// exports
exports.locals = {
	"container": "_2ABq6",
	"section": "_1wdVL",
	"contentImage": "_4VQaZ",
	"services": "_3rEyO"
};

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)(false);
// imports


// module
exports.push([module.i, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n */\n/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{margin:.67em 0;font-size:2em}mark{color:#000;background:#ff0}small{font-size:80%}sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{height:0;-webkit-box-sizing:content-box;box-sizing:content-box}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{margin:0;font:inherit;color:inherit}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{padding:0;border:0}input{line-height:normal}input[type=checkbox],input[type=radio]{-webkit-box-sizing:border-box;box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-box-sizing:content-box;box-sizing:content-box;-webkit-appearance:textfield}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{padding:.35em .625em .75em;margin:0 2px;border:1px solid silver}textarea{overflow:auto}optgroup{font-weight:700}table{border-spacing:0;border-collapse:collapse}td,th{padding:0}\n/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{color:#000!important;text-shadow:none!important;background:0 0!important;-webkit-box-shadow:none!important;box-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(297) + ");src:url(" + __webpack_require__(297) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(694) + ") format(\"woff2\"),url(" + __webpack_require__(695) + ") format(\"woff\"),url(" + __webpack_require__(696) + ") format(\"truetype\"),url(" + __webpack_require__(697) + "#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{display:inline-block;max-width:100%;height:auto;padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:all .2s ease-in-out;-o-transition:all .2s ease-in-out;transition:all .2s ease-in-out}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{padding:.2em;background-color:#fcf8e3}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-right:5px;padding-left:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;overflow:hidden;clear:left;text-align:right;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;text-align:right;border-right:5px solid #eee;border-left:0}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.25);box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;-webkit-box-shadow:none;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;color:#333;word-break:break-all;word-wrap:break-word;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}.row{margin-right:-15px;margin-left:-15px}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-right:15px;padding-left:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;display:table-column;float:none}table td[class*=col-],table th[class*=col-]{position:static;display:table-cell;float:none}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{min-height:.01%;overflow-x:auto}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{min-width:0}legend{display:block;width:100%;padding:0;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border:0;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{-webkit-box-sizing:border-box;box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075);-webkit-transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;-o-transition:border-color ease-in-out .15s,box-shadow ease-in-out .15s;transition:border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{background-color:transparent;border:0}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-top:4px\\9;margin-left:-20px}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;font-weight:400;vertical-align:middle;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{min-height:34px;padding-top:7px;padding-bottom:7px;margin-bottom:0}.form-control-static.input-lg,.form-control-static.input-sm{padding-right:0;padding-left:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;background-color:#dff0d8;border-color:#3c763d}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;background-color:#fcf8e3;border-color:#8a6d3b}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075);box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;background-color:#f2dede;border-color:#a94442}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{padding-top:7px;margin-top:0;margin-bottom:0}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.form-horizontal .control-label{padding-top:7px;margin-bottom:0;text-align:right}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:none;border:1px solid transparent;border-radius:4px}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{background-image:none;outline:0;-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;filter:alpha(opacity=65);-webkit-box-shadow:none;box-shadow:none;opacity:.65}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{font-weight:400;color:#337ab7;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;-webkit-box-shadow:none;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;-webkit-transition:opacity .15s linear;-o-transition:opacity .15s linear;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;-webkit-transition-timing-function:ease;-o-transition-timing-function:ease;transition-timing-function:ease;-webkit-transition-duration:.35s;-o-transition-duration:.35s;transition-duration:.35s;-webkit-transition-property:height,visibility;-o-transition-property:height,visibility;transition-property:height,visibility}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175)}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{color:#262626;text-decoration:none;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;background-color:#337ab7;outline:0}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;cursor:not-allowed;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled=false)}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{right:0;left:auto}.dropdown-menu-left{right:auto;left:0}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{content:\"\";border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{right:auto;left:0}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-top-left-radius:0;border-bottom-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-top-right-radius:0;border-bottom-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-bottom-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-right:8px;padding-left:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-right:12px;padding-left:12px}.btn-group.open .dropdown-toggle{-webkit-box-shadow:inset 0 3px 5px rgba(0,0,0,.125);box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{-webkit-box-shadow:none;box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-left-radius:0;border-top-right-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-left-radius:0;border-top-right-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{display:table-cell;float:none;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-right:0;padding-left:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{padding-left:0;margin-bottom:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;cursor:not-allowed;background-color:transparent}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;cursor:default;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{margin-bottom:5px;text-align:center}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-left-radius:0;border-top-right-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{padding-right:15px;padding-left:15px;overflow-x:visible;-webkit-overflow-scrolling:touch;border-top:1px solid transparent;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1)}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;-webkit-box-shadow:none;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-right:0;padding-left:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;height:50px;padding:15px;font-size:18px;line-height:20px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;padding:9px 10px;margin-top:8px;margin-right:15px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;-webkit-box-shadow:none;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{padding:10px 15px;margin:8px -15px;border-top:1px solid transparent;border-bottom:1px solid transparent;-webkit-box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1);box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;padding-top:0;padding-bottom:0;margin-right:0;margin-left:0;border:0;-webkit-box-shadow:none;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-left-radius:0;border-top-right-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-right:15px;margin-left:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{color:#555;background-color:#e7e7e7}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{color:#fff;background-color:#080808}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{padding:0 5px;color:#ccc;content:\"/\\A0\"}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;margin-left:-1px;line-height:1.42857143;color:#337ab7;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;cursor:default;background-color:#337ab7;border-color:#337ab7}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;cursor:not-allowed;background-color:#fff;border-color:#ddd}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-top-left-radius:6px;border-bottom-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-top-right-radius:6px;border-bottom-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px}.pager{padding-left:0;margin:20px 0;text-align:center;list-style:none}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;cursor:not-allowed;background-color:#fff}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:middle;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{padding-right:15px;padding-left:15px;border-radius:6px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-right:60px;padding-left:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;-webkit-transition:border .2s ease-in-out;-o-transition:border .2s ease-in-out;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-right:auto;margin-left:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.thumbnail .caption{padding:9px;color:#333}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{height:20px;margin-bottom:20px;overflow:hidden;background-color:#f5f5f5;border-radius:4px;-webkit-box-shadow:inset 0 1px 2px rgba(0,0,0,.1);box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-transition:width .6s ease;-o-transition:width .6s ease;transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:-webkit-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-image:-o-linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 25%,transparent 50%,hsla(0,0%,100%,.15) 50%,hsla(0,0%,100%,.15) 75%,transparent 75%,transparent);background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{overflow:hidden;zoom:1}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{padding-left:0;margin-bottom:20px}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-left-radius:4px;border-top-right-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{color:#555;text-decoration:none;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{color:#777;cursor:not-allowed;background-color:#eee}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;-webkit-box-shadow:0 1px 1px rgba(0,0,0,.05);box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-left-radius:3px;border-top-right-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-left-radius:3px;border-top-right-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-left-radius:0;border-top-right-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-right:15px;padding-left:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-left-radius:3px;border-top-right-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{margin-bottom:0;border:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;-webkit-box-shadow:inset 0 1px 1px rgba(0,0,0,.05);box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;filter:alpha(opacity=50);opacity:.5}button.close{-webkit-appearance:none;padding:0;cursor:pointer;background:0 0;border:0}.modal,.modal-open{overflow:hidden}.modal{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;display:none;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{-webkit-transition:-webkit-transform .3s ease-out;-o-transition:-o-transform .3s ease-out;transition:-webkit-transform .3s ease-out;-o-transition:transform .3s ease-out;transition:transform .3s ease-out;transition:transform .3s ease-out,-webkit-transform .3s ease-out;-webkit-transform:translateY(-25%);-ms-transform:translateY(-25%);transform:translateY(-25%)}.modal.in .modal-dialog{-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;background-clip:padding-box;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;outline:0;-webkit-box-shadow:0 3px 9px rgba(0,0,0,.5);box-shadow:0 3px 9px rgba(0,0,0,.5)}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{filter:alpha(opacity=0);opacity:0}.modal-backdrop.in{filter:alpha(opacity=50);opacity:.5}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-bottom:0;margin-left:5px}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{-webkit-box-shadow:0 5px 15px rgba(0,0,0,.5);box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:12px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;filter:alpha(opacity=0);opacity:0;line-break:auto}.tooltip.in{filter:alpha(opacity=90);opacity:.9}.tooltip.top{padding:5px 0;margin-top:-3px}.tooltip.right{padding:0 5px;margin-left:3px}.tooltip.bottom{padding:5px 0;margin-top:3px}.tooltip.left{padding:0 5px;margin-left:-3px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;font-style:normal;font-weight:400;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;letter-spacing:normal;word-break:normal;word-spacing:normal;word-wrap:normal;white-space:normal;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;-webkit-box-shadow:0 5px 10px rgba(0,0,0,.2);box-shadow:0 5px 10px rgba(0,0,0,.2);line-break:auto}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{padding:8px 14px;margin:0;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{content:\"\";border-width:10px}.popover.top>.arrow{bottom:-11px;left:50%;margin-left:-11px;border-top-color:#999;border-top-color:rgba(0,0,0,.25);border-bottom-width:0}.popover.top>.arrow:after{bottom:1px;margin-left:-10px;content:\" \";border-top-color:#fff;border-bottom-width:0}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-right-color:#999;border-right-color:rgba(0,0,0,.25);border-left-width:0}.popover.right>.arrow:after{bottom:-10px;left:1px;content:\" \";border-right-color:#fff;border-left-width:0}.popover.bottom>.arrow{top:-11px;left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25)}.popover.bottom>.arrow:after{top:1px;margin-left:-10px;content:\" \";border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{right:1px;bottom:-10px;content:\" \";border-right-width:0;border-left-color:#fff}.carousel,.carousel-inner{position:relative}.carousel-inner{width:100%;overflow:hidden}.carousel-inner>.item{position:relative;display:none;-webkit-transition:left .6s ease-in-out;-o-transition:.6s ease-in-out left;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{-webkit-transition:-webkit-transform .6s ease-in-out;-o-transition:-o-transform .6s ease-in-out;transition:-webkit-transform .6s ease-in-out;-o-transition:transform .6s ease-in-out;transition:transform .6s ease-in-out;transition:transform .6s ease-in-out,-webkit-transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{left:0;-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0)}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{left:0;-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0)}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{left:0;-webkit-transform:translateZ(0);transform:translateZ(0)}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;bottom:0;left:0;width:15%;font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent;filter:alpha(opacity=50);opacity:.5}.carousel-control.left{background-image:-webkit-linear-gradient(left,rgba(0,0,0,.5),rgba(0,0,0,.0001));background-image:-o-linear-gradient(left,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001) 100%);background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,.0001)));background-image:-webkit-gradient(linear,left top,right top,color-stop(0,rgba(0,0,0,.5)),to(rgba(0,0,0,.0001)));background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1);background-repeat:repeat-x}.carousel-control.right{right:0;left:auto;background-image:-webkit-linear-gradient(left,rgba(0,0,0,.0001),rgba(0,0,0,.5));background-image:-o-linear-gradient(left,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5) 100%);background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.0001)),to(rgba(0,0,0,.5)));background-image:-webkit-gradient(linear,left top,right top,color-stop(0,rgba(0,0,0,.0001)),to(rgba(0,0,0,.5)));background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1);background-repeat:repeat-x}.carousel-control:focus,.carousel-control:hover{color:#fff;text-decoration:none;filter:alpha(opacity=90);outline:0;opacity:.9}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-10px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;font-family:serif;line-height:1}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;padding-left:0;margin-left:-30%;text-align:center;list-style:none}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;cursor:pointer;background-color:#000\\9;background-color:transparent;border:1px solid #fff;border-radius:10px}.carousel-indicators .active{width:12px;height:12px;margin:0;background-color:#fff}.carousel-caption{position:absolute;right:15%;bottom:20px;left:15%;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{right:20%;left:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{display:table;content:\" \"}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-right:auto;margin-left:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}#app,.root-container,body,html{height:100%}body{padding-top:52px}.content{min-height:100%;margin-bottom:-271px;padding:0 20px}@media (max-width:480px){.content{padding:0 10px}}.content:after{display:block;height:271px;content:\"\"}body{margin:0}a{color:#2196f3}::-moz-selection{background:#00bcd4;text-shadow:none}::selection{background:#00bcd4;text-shadow:none}hr{display:block;height:1px;border:0;border-top:1px solid #7a7a7a;margin:1em 0;padding:0}audio,canvas,iframe,img,svg,video{vertical-align:middle}fieldset{border:0;margin:0;padding:0}textarea{resize:vertical}.browserupgrade{margin:.2em 0;background:#fbfbfb;color:#333;padding:.2em 0}@media print{*,:after,:before{background:transparent!important;color:#000!important;-webkit-box-shadow:none!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}}body,html{color:#646464;font-weight:100;font-size:1em;font-family:Gotham Rounded A,Gotham Rounded B,HelveticaNeue-Light,Arial,sans-serif;line-height:1.375}h1,h2,h3,h4,h5,h6{color:#646464;font-family:Gotham SSm A,Gotham SSm B,HelveticaNeue-Light,Arial,sans-serif;font-weight:400}h1,h2{color:#00dcb2}h1{line-height:28px;line-height:2.8rem}h2{letter-spacing:2.2px;letter-spacing:.22rem}h2,h3{font-size:12px;font-size:1.2rem}h3{font-family:Gotham SSm A,Gotham SSm B,HelveticaNeue-Light,sans-serif;font-style:normal;font-weight:400}.small{font-size:7px;font-size:.7rem}.teal{color:#00dcb2}.purple{color:#673ab7}.orange{color:#ff3737}.top-nav{max-width:1000px;margin:0 auto;padding-left:15px;font-family:Gotham SSm A,Gotham SSm B,HelveticaNeue-Light,Arial,sans-serif;font-size:10px;font-size:1rem;background:#fff;border:0;z-index:20}.top-nav .navbar-right .dropdown .caret{display:none}.navbar-default .navbar-brand,.navbar-default .navbar-nav>li>a{color:#646464}.navbar-default .navbar-nav .dropdonw-toggle a:focus,.navbar-default .navbar-nav .dropdown-toggle a:active,.navbar-default .navbar-nav .dropdown-toggle a:hover,.navbar-default .navbar-nav .dropdown.open>.dropdown-toggle{color:#00dcb2;background:#e6e6e6}.navbar-default .dropdown-menu{border-radius:0;-webkit-box-shadow:none;box-shadow:none}.navbar-default .dropdown-menu>li>a{padding:10px 25px;color:#646464;font-weight:400;text-transform:uppercase}.navbar-default .navbar-brand{padding:0}.navbar-default .navbar-brand img{display:block;height:100%}.navbar-default .navbar-nav>li>a{text-transform:uppercase}.btn-teal{color:#fff;background:#00dcb2}.btn--small{padding:2px 8px;font-size:8px;font-size:.8rem}", ""]);

// exports
exports.locals = {
	"navbar": "navbar",
	"btn": "btn",
	"caret": "caret",
	"dropup": "dropup",
	"label": "label",
	"table": "table",
	"table-bordered": "table-bordered",
	"glyphicon": "glyphicon",
	"glyphicon-asterisk": "glyphicon-asterisk",
	"glyphicon-plus": "glyphicon-plus",
	"glyphicon-eur": "glyphicon-eur",
	"glyphicon-euro": "glyphicon-euro",
	"glyphicon-minus": "glyphicon-minus",
	"glyphicon-cloud": "glyphicon-cloud",
	"glyphicon-envelope": "glyphicon-envelope",
	"glyphicon-pencil": "glyphicon-pencil",
	"glyphicon-glass": "glyphicon-glass",
	"glyphicon-music": "glyphicon-music",
	"glyphicon-search": "glyphicon-search",
	"glyphicon-heart": "glyphicon-heart",
	"glyphicon-star": "glyphicon-star",
	"glyphicon-star-empty": "glyphicon-star-empty",
	"glyphicon-user": "glyphicon-user",
	"glyphicon-film": "glyphicon-film",
	"glyphicon-th-large": "glyphicon-th-large",
	"glyphicon-th": "glyphicon-th",
	"glyphicon-th-list": "glyphicon-th-list",
	"glyphicon-ok": "glyphicon-ok",
	"glyphicon-remove": "glyphicon-remove",
	"glyphicon-zoom-in": "glyphicon-zoom-in",
	"glyphicon-zoom-out": "glyphicon-zoom-out",
	"glyphicon-off": "glyphicon-off",
	"glyphicon-signal": "glyphicon-signal",
	"glyphicon-cog": "glyphicon-cog",
	"glyphicon-trash": "glyphicon-trash",
	"glyphicon-home": "glyphicon-home",
	"glyphicon-file": "glyphicon-file",
	"glyphicon-time": "glyphicon-time",
	"glyphicon-road": "glyphicon-road",
	"glyphicon-download-alt": "glyphicon-download-alt",
	"glyphicon-download": "glyphicon-download",
	"glyphicon-upload": "glyphicon-upload",
	"glyphicon-inbox": "glyphicon-inbox",
	"glyphicon-play-circle": "glyphicon-play-circle",
	"glyphicon-repeat": "glyphicon-repeat",
	"glyphicon-refresh": "glyphicon-refresh",
	"glyphicon-list-alt": "glyphicon-list-alt",
	"glyphicon-lock": "glyphicon-lock",
	"glyphicon-flag": "glyphicon-flag",
	"glyphicon-headphones": "glyphicon-headphones",
	"glyphicon-volume-off": "glyphicon-volume-off",
	"glyphicon-volume-down": "glyphicon-volume-down",
	"glyphicon-volume-up": "glyphicon-volume-up",
	"glyphicon-qrcode": "glyphicon-qrcode",
	"glyphicon-barcode": "glyphicon-barcode",
	"glyphicon-tag": "glyphicon-tag",
	"glyphicon-tags": "glyphicon-tags",
	"glyphicon-book": "glyphicon-book",
	"glyphicon-bookmark": "glyphicon-bookmark",
	"glyphicon-print": "glyphicon-print",
	"glyphicon-camera": "glyphicon-camera",
	"glyphicon-font": "glyphicon-font",
	"glyphicon-bold": "glyphicon-bold",
	"glyphicon-italic": "glyphicon-italic",
	"glyphicon-text-height": "glyphicon-text-height",
	"glyphicon-text-width": "glyphicon-text-width",
	"glyphicon-align-left": "glyphicon-align-left",
	"glyphicon-align-center": "glyphicon-align-center",
	"glyphicon-align-right": "glyphicon-align-right",
	"glyphicon-align-justify": "glyphicon-align-justify",
	"glyphicon-list": "glyphicon-list",
	"glyphicon-indent-left": "glyphicon-indent-left",
	"glyphicon-indent-right": "glyphicon-indent-right",
	"glyphicon-facetime-video": "glyphicon-facetime-video",
	"glyphicon-picture": "glyphicon-picture",
	"glyphicon-map-marker": "glyphicon-map-marker",
	"glyphicon-adjust": "glyphicon-adjust",
	"glyphicon-tint": "glyphicon-tint",
	"glyphicon-edit": "glyphicon-edit",
	"glyphicon-share": "glyphicon-share",
	"glyphicon-check": "glyphicon-check",
	"glyphicon-move": "glyphicon-move",
	"glyphicon-step-backward": "glyphicon-step-backward",
	"glyphicon-fast-backward": "glyphicon-fast-backward",
	"glyphicon-backward": "glyphicon-backward",
	"glyphicon-play": "glyphicon-play",
	"glyphicon-pause": "glyphicon-pause",
	"glyphicon-stop": "glyphicon-stop",
	"glyphicon-forward": "glyphicon-forward",
	"glyphicon-fast-forward": "glyphicon-fast-forward",
	"glyphicon-step-forward": "glyphicon-step-forward",
	"glyphicon-eject": "glyphicon-eject",
	"glyphicon-chevron-left": "glyphicon-chevron-left",
	"glyphicon-chevron-right": "glyphicon-chevron-right",
	"glyphicon-plus-sign": "glyphicon-plus-sign",
	"glyphicon-minus-sign": "glyphicon-minus-sign",
	"glyphicon-remove-sign": "glyphicon-remove-sign",
	"glyphicon-ok-sign": "glyphicon-ok-sign",
	"glyphicon-question-sign": "glyphicon-question-sign",
	"glyphicon-info-sign": "glyphicon-info-sign",
	"glyphicon-screenshot": "glyphicon-screenshot",
	"glyphicon-remove-circle": "glyphicon-remove-circle",
	"glyphicon-ok-circle": "glyphicon-ok-circle",
	"glyphicon-ban-circle": "glyphicon-ban-circle",
	"glyphicon-arrow-left": "glyphicon-arrow-left",
	"glyphicon-arrow-right": "glyphicon-arrow-right",
	"glyphicon-arrow-up": "glyphicon-arrow-up",
	"glyphicon-arrow-down": "glyphicon-arrow-down",
	"glyphicon-share-alt": "glyphicon-share-alt",
	"glyphicon-resize-full": "glyphicon-resize-full",
	"glyphicon-resize-small": "glyphicon-resize-small",
	"glyphicon-exclamation-sign": "glyphicon-exclamation-sign",
	"glyphicon-gift": "glyphicon-gift",
	"glyphicon-leaf": "glyphicon-leaf",
	"glyphicon-fire": "glyphicon-fire",
	"glyphicon-eye-open": "glyphicon-eye-open",
	"glyphicon-eye-close": "glyphicon-eye-close",
	"glyphicon-warning-sign": "glyphicon-warning-sign",
	"glyphicon-plane": "glyphicon-plane",
	"glyphicon-calendar": "glyphicon-calendar",
	"glyphicon-random": "glyphicon-random",
	"glyphicon-comment": "glyphicon-comment",
	"glyphicon-magnet": "glyphicon-magnet",
	"glyphicon-chevron-up": "glyphicon-chevron-up",
	"glyphicon-chevron-down": "glyphicon-chevron-down",
	"glyphicon-retweet": "glyphicon-retweet",
	"glyphicon-shopping-cart": "glyphicon-shopping-cart",
	"glyphicon-folder-close": "glyphicon-folder-close",
	"glyphicon-folder-open": "glyphicon-folder-open",
	"glyphicon-resize-vertical": "glyphicon-resize-vertical",
	"glyphicon-resize-horizontal": "glyphicon-resize-horizontal",
	"glyphicon-hdd": "glyphicon-hdd",
	"glyphicon-bullhorn": "glyphicon-bullhorn",
	"glyphicon-bell": "glyphicon-bell",
	"glyphicon-certificate": "glyphicon-certificate",
	"glyphicon-thumbs-up": "glyphicon-thumbs-up",
	"glyphicon-thumbs-down": "glyphicon-thumbs-down",
	"glyphicon-hand-right": "glyphicon-hand-right",
	"glyphicon-hand-left": "glyphicon-hand-left",
	"glyphicon-hand-up": "glyphicon-hand-up",
	"glyphicon-hand-down": "glyphicon-hand-down",
	"glyphicon-circle-arrow-right": "glyphicon-circle-arrow-right",
	"glyphicon-circle-arrow-left": "glyphicon-circle-arrow-left",
	"glyphicon-circle-arrow-up": "glyphicon-circle-arrow-up",
	"glyphicon-circle-arrow-down": "glyphicon-circle-arrow-down",
	"glyphicon-globe": "glyphicon-globe",
	"glyphicon-wrench": "glyphicon-wrench",
	"glyphicon-tasks": "glyphicon-tasks",
	"glyphicon-filter": "glyphicon-filter",
	"glyphicon-briefcase": "glyphicon-briefcase",
	"glyphicon-fullscreen": "glyphicon-fullscreen",
	"glyphicon-dashboard": "glyphicon-dashboard",
	"glyphicon-paperclip": "glyphicon-paperclip",
	"glyphicon-heart-empty": "glyphicon-heart-empty",
	"glyphicon-link": "glyphicon-link",
	"glyphicon-phone": "glyphicon-phone",
	"glyphicon-pushpin": "glyphicon-pushpin",
	"glyphicon-usd": "glyphicon-usd",
	"glyphicon-gbp": "glyphicon-gbp",
	"glyphicon-sort": "glyphicon-sort",
	"glyphicon-sort-by-alphabet": "glyphicon-sort-by-alphabet",
	"glyphicon-sort-by-alphabet-alt": "glyphicon-sort-by-alphabet-alt",
	"glyphicon-sort-by-order": "glyphicon-sort-by-order",
	"glyphicon-sort-by-order-alt": "glyphicon-sort-by-order-alt",
	"glyphicon-sort-by-attributes": "glyphicon-sort-by-attributes",
	"glyphicon-sort-by-attributes-alt": "glyphicon-sort-by-attributes-alt",
	"glyphicon-unchecked": "glyphicon-unchecked",
	"glyphicon-expand": "glyphicon-expand",
	"glyphicon-collapse-down": "glyphicon-collapse-down",
	"glyphicon-collapse-up": "glyphicon-collapse-up",
	"glyphicon-log-in": "glyphicon-log-in",
	"glyphicon-flash": "glyphicon-flash",
	"glyphicon-log-out": "glyphicon-log-out",
	"glyphicon-new-window": "glyphicon-new-window",
	"glyphicon-record": "glyphicon-record",
	"glyphicon-save": "glyphicon-save",
	"glyphicon-open": "glyphicon-open",
	"glyphicon-saved": "glyphicon-saved",
	"glyphicon-import": "glyphicon-import",
	"glyphicon-export": "glyphicon-export",
	"glyphicon-send": "glyphicon-send",
	"glyphicon-floppy-disk": "glyphicon-floppy-disk",
	"glyphicon-floppy-saved": "glyphicon-floppy-saved",
	"glyphicon-floppy-remove": "glyphicon-floppy-remove",
	"glyphicon-floppy-save": "glyphicon-floppy-save",
	"glyphicon-floppy-open": "glyphicon-floppy-open",
	"glyphicon-credit-card": "glyphicon-credit-card",
	"glyphicon-transfer": "glyphicon-transfer",
	"glyphicon-cutlery": "glyphicon-cutlery",
	"glyphicon-header": "glyphicon-header",
	"glyphicon-compressed": "glyphicon-compressed",
	"glyphicon-earphone": "glyphicon-earphone",
	"glyphicon-phone-alt": "glyphicon-phone-alt",
	"glyphicon-tower": "glyphicon-tower",
	"glyphicon-stats": "glyphicon-stats",
	"glyphicon-sd-video": "glyphicon-sd-video",
	"glyphicon-hd-video": "glyphicon-hd-video",
	"glyphicon-subtitles": "glyphicon-subtitles",
	"glyphicon-sound-stereo": "glyphicon-sound-stereo",
	"glyphicon-sound-dolby": "glyphicon-sound-dolby",
	"glyphicon-sound-5-1": "glyphicon-sound-5-1",
	"glyphicon-sound-6-1": "glyphicon-sound-6-1",
	"glyphicon-sound-7-1": "glyphicon-sound-7-1",
	"glyphicon-copyright-mark": "glyphicon-copyright-mark",
	"glyphicon-registration-mark": "glyphicon-registration-mark",
	"glyphicon-cloud-download": "glyphicon-cloud-download",
	"glyphicon-cloud-upload": "glyphicon-cloud-upload",
	"glyphicon-tree-conifer": "glyphicon-tree-conifer",
	"glyphicon-tree-deciduous": "glyphicon-tree-deciduous",
	"glyphicon-cd": "glyphicon-cd",
	"glyphicon-save-file": "glyphicon-save-file",
	"glyphicon-open-file": "glyphicon-open-file",
	"glyphicon-level-up": "glyphicon-level-up",
	"glyphicon-copy": "glyphicon-copy",
	"glyphicon-paste": "glyphicon-paste",
	"glyphicon-alert": "glyphicon-alert",
	"glyphicon-equalizer": "glyphicon-equalizer",
	"glyphicon-king": "glyphicon-king",
	"glyphicon-queen": "glyphicon-queen",
	"glyphicon-pawn": "glyphicon-pawn",
	"glyphicon-bishop": "glyphicon-bishop",
	"glyphicon-knight": "glyphicon-knight",
	"glyphicon-baby-formula": "glyphicon-baby-formula",
	"glyphicon-tent": "glyphicon-tent",
	"glyphicon-blackboard": "glyphicon-blackboard",
	"glyphicon-bed": "glyphicon-bed",
	"glyphicon-apple": "glyphicon-apple",
	"glyphicon-erase": "glyphicon-erase",
	"glyphicon-hourglass": "glyphicon-hourglass",
	"glyphicon-lamp": "glyphicon-lamp",
	"glyphicon-duplicate": "glyphicon-duplicate",
	"glyphicon-piggy-bank": "glyphicon-piggy-bank",
	"glyphicon-scissors": "glyphicon-scissors",
	"glyphicon-bitcoin": "glyphicon-bitcoin",
	"glyphicon-btc": "glyphicon-btc",
	"glyphicon-xbt": "glyphicon-xbt",
	"glyphicon-yen": "glyphicon-yen",
	"glyphicon-jpy": "glyphicon-jpy",
	"glyphicon-ruble": "glyphicon-ruble",
	"glyphicon-rub": "glyphicon-rub",
	"glyphicon-scale": "glyphicon-scale",
	"glyphicon-ice-lolly": "glyphicon-ice-lolly",
	"glyphicon-ice-lolly-tasted": "glyphicon-ice-lolly-tasted",
	"glyphicon-education": "glyphicon-education",
	"glyphicon-option-horizontal": "glyphicon-option-horizontal",
	"glyphicon-option-vertical": "glyphicon-option-vertical",
	"glyphicon-menu-hamburger": "glyphicon-menu-hamburger",
	"glyphicon-modal-window": "glyphicon-modal-window",
	"glyphicon-oil": "glyphicon-oil",
	"glyphicon-grain": "glyphicon-grain",
	"glyphicon-sunglasses": "glyphicon-sunglasses",
	"glyphicon-text-size": "glyphicon-text-size",
	"glyphicon-text-color": "glyphicon-text-color",
	"glyphicon-text-background": "glyphicon-text-background",
	"glyphicon-object-align-top": "glyphicon-object-align-top",
	"glyphicon-object-align-bottom": "glyphicon-object-align-bottom",
	"glyphicon-object-align-horizontal": "glyphicon-object-align-horizontal",
	"glyphicon-object-align-left": "glyphicon-object-align-left",
	"glyphicon-object-align-vertical": "glyphicon-object-align-vertical",
	"glyphicon-object-align-right": "glyphicon-object-align-right",
	"glyphicon-triangle-right": "glyphicon-triangle-right",
	"glyphicon-triangle-left": "glyphicon-triangle-left",
	"glyphicon-triangle-bottom": "glyphicon-triangle-bottom",
	"glyphicon-triangle-top": "glyphicon-triangle-top",
	"glyphicon-console": "glyphicon-console",
	"glyphicon-superscript": "glyphicon-superscript",
	"glyphicon-subscript": "glyphicon-subscript",
	"glyphicon-menu-left": "glyphicon-menu-left",
	"glyphicon-menu-right": "glyphicon-menu-right",
	"glyphicon-menu-down": "glyphicon-menu-down",
	"glyphicon-menu-up": "glyphicon-menu-up",
	"carousel-inner": "carousel-inner",
	"item": "item",
	"img-responsive": "img-responsive",
	"thumbnail": "thumbnail",
	"img-rounded": "img-rounded",
	"img-thumbnail": "img-thumbnail",
	"img-circle": "img-circle",
	"sr-only": "sr-only",
	"sr-only-focusable": "sr-only-focusable",
	"h1": "h1",
	"h2": "h2",
	"h3": "h3",
	"h4": "h4",
	"h5": "h5",
	"h6": "h6",
	"small": "small",
	"lead": "lead",
	"mark": "mark",
	"text-left": "text-left",
	"text-right": "text-right",
	"text-center": "text-center",
	"text-justify": "text-justify",
	"text-nowrap": "text-nowrap",
	"text-lowercase": "text-lowercase",
	"text-uppercase": "text-uppercase",
	"text-capitalize": "text-capitalize",
	"text-muted": "text-muted",
	"text-primary": "text-primary",
	"text-success": "text-success",
	"text-info": "text-info",
	"text-warning": "text-warning",
	"text-danger": "text-danger",
	"bg-primary": "bg-primary",
	"bg-success": "bg-success",
	"bg-info": "bg-info",
	"bg-warning": "bg-warning",
	"bg-danger": "bg-danger",
	"page-header": "page-header",
	"list-unstyled": "list-unstyled",
	"list-inline": "list-inline",
	"dl-horizontal": "dl-horizontal",
	"initialism": "initialism",
	"blockquote-reverse": "blockquote-reverse",
	"pull-right": "pull-right",
	"pre-scrollable": "pre-scrollable",
	"container": "container",
	"container-fluid": "container-fluid",
	"row": "row",
	"col-lg-1": "col-lg-1",
	"col-lg-10": "col-lg-10",
	"col-lg-11": "col-lg-11",
	"col-lg-12": "col-lg-12",
	"col-lg-2": "col-lg-2",
	"col-lg-3": "col-lg-3",
	"col-lg-4": "col-lg-4",
	"col-lg-5": "col-lg-5",
	"col-lg-6": "col-lg-6",
	"col-lg-7": "col-lg-7",
	"col-lg-8": "col-lg-8",
	"col-lg-9": "col-lg-9",
	"col-md-1": "col-md-1",
	"col-md-10": "col-md-10",
	"col-md-11": "col-md-11",
	"col-md-12": "col-md-12",
	"col-md-2": "col-md-2",
	"col-md-3": "col-md-3",
	"col-md-4": "col-md-4",
	"col-md-5": "col-md-5",
	"col-md-6": "col-md-6",
	"col-md-7": "col-md-7",
	"col-md-8": "col-md-8",
	"col-md-9": "col-md-9",
	"col-sm-1": "col-sm-1",
	"col-sm-10": "col-sm-10",
	"col-sm-11": "col-sm-11",
	"col-sm-12": "col-sm-12",
	"col-sm-2": "col-sm-2",
	"col-sm-3": "col-sm-3",
	"col-sm-4": "col-sm-4",
	"col-sm-5": "col-sm-5",
	"col-sm-6": "col-sm-6",
	"col-sm-7": "col-sm-7",
	"col-sm-8": "col-sm-8",
	"col-sm-9": "col-sm-9",
	"col-xs-1": "col-xs-1",
	"col-xs-10": "col-xs-10",
	"col-xs-11": "col-xs-11",
	"col-xs-12": "col-xs-12",
	"col-xs-2": "col-xs-2",
	"col-xs-3": "col-xs-3",
	"col-xs-4": "col-xs-4",
	"col-xs-5": "col-xs-5",
	"col-xs-6": "col-xs-6",
	"col-xs-7": "col-xs-7",
	"col-xs-8": "col-xs-8",
	"col-xs-9": "col-xs-9",
	"col-xs-pull-12": "col-xs-pull-12",
	"col-xs-pull-11": "col-xs-pull-11",
	"col-xs-pull-10": "col-xs-pull-10",
	"col-xs-pull-9": "col-xs-pull-9",
	"col-xs-pull-8": "col-xs-pull-8",
	"col-xs-pull-7": "col-xs-pull-7",
	"col-xs-pull-6": "col-xs-pull-6",
	"col-xs-pull-5": "col-xs-pull-5",
	"col-xs-pull-4": "col-xs-pull-4",
	"col-xs-pull-3": "col-xs-pull-3",
	"col-xs-pull-2": "col-xs-pull-2",
	"col-xs-pull-1": "col-xs-pull-1",
	"col-xs-pull-0": "col-xs-pull-0",
	"col-xs-push-12": "col-xs-push-12",
	"col-xs-push-11": "col-xs-push-11",
	"col-xs-push-10": "col-xs-push-10",
	"col-xs-push-9": "col-xs-push-9",
	"col-xs-push-8": "col-xs-push-8",
	"col-xs-push-7": "col-xs-push-7",
	"col-xs-push-6": "col-xs-push-6",
	"col-xs-push-5": "col-xs-push-5",
	"col-xs-push-4": "col-xs-push-4",
	"col-xs-push-3": "col-xs-push-3",
	"col-xs-push-2": "col-xs-push-2",
	"col-xs-push-1": "col-xs-push-1",
	"col-xs-push-0": "col-xs-push-0",
	"col-xs-offset-12": "col-xs-offset-12",
	"col-xs-offset-11": "col-xs-offset-11",
	"col-xs-offset-10": "col-xs-offset-10",
	"col-xs-offset-9": "col-xs-offset-9",
	"col-xs-offset-8": "col-xs-offset-8",
	"col-xs-offset-7": "col-xs-offset-7",
	"col-xs-offset-6": "col-xs-offset-6",
	"col-xs-offset-5": "col-xs-offset-5",
	"col-xs-offset-4": "col-xs-offset-4",
	"col-xs-offset-3": "col-xs-offset-3",
	"col-xs-offset-2": "col-xs-offset-2",
	"col-xs-offset-1": "col-xs-offset-1",
	"col-xs-offset-0": "col-xs-offset-0",
	"col-sm-pull-12": "col-sm-pull-12",
	"col-sm-pull-11": "col-sm-pull-11",
	"col-sm-pull-10": "col-sm-pull-10",
	"col-sm-pull-9": "col-sm-pull-9",
	"col-sm-pull-8": "col-sm-pull-8",
	"col-sm-pull-7": "col-sm-pull-7",
	"col-sm-pull-6": "col-sm-pull-6",
	"col-sm-pull-5": "col-sm-pull-5",
	"col-sm-pull-4": "col-sm-pull-4",
	"col-sm-pull-3": "col-sm-pull-3",
	"col-sm-pull-2": "col-sm-pull-2",
	"col-sm-pull-1": "col-sm-pull-1",
	"col-sm-pull-0": "col-sm-pull-0",
	"col-sm-push-12": "col-sm-push-12",
	"col-sm-push-11": "col-sm-push-11",
	"col-sm-push-10": "col-sm-push-10",
	"col-sm-push-9": "col-sm-push-9",
	"col-sm-push-8": "col-sm-push-8",
	"col-sm-push-7": "col-sm-push-7",
	"col-sm-push-6": "col-sm-push-6",
	"col-sm-push-5": "col-sm-push-5",
	"col-sm-push-4": "col-sm-push-4",
	"col-sm-push-3": "col-sm-push-3",
	"col-sm-push-2": "col-sm-push-2",
	"col-sm-push-1": "col-sm-push-1",
	"col-sm-push-0": "col-sm-push-0",
	"col-sm-offset-12": "col-sm-offset-12",
	"col-sm-offset-11": "col-sm-offset-11",
	"col-sm-offset-10": "col-sm-offset-10",
	"col-sm-offset-9": "col-sm-offset-9",
	"col-sm-offset-8": "col-sm-offset-8",
	"col-sm-offset-7": "col-sm-offset-7",
	"col-sm-offset-6": "col-sm-offset-6",
	"col-sm-offset-5": "col-sm-offset-5",
	"col-sm-offset-4": "col-sm-offset-4",
	"col-sm-offset-3": "col-sm-offset-3",
	"col-sm-offset-2": "col-sm-offset-2",
	"col-sm-offset-1": "col-sm-offset-1",
	"col-sm-offset-0": "col-sm-offset-0",
	"col-md-pull-12": "col-md-pull-12",
	"col-md-pull-11": "col-md-pull-11",
	"col-md-pull-10": "col-md-pull-10",
	"col-md-pull-9": "col-md-pull-9",
	"col-md-pull-8": "col-md-pull-8",
	"col-md-pull-7": "col-md-pull-7",
	"col-md-pull-6": "col-md-pull-6",
	"col-md-pull-5": "col-md-pull-5",
	"col-md-pull-4": "col-md-pull-4",
	"col-md-pull-3": "col-md-pull-3",
	"col-md-pull-2": "col-md-pull-2",
	"col-md-pull-1": "col-md-pull-1",
	"col-md-pull-0": "col-md-pull-0",
	"col-md-push-12": "col-md-push-12",
	"col-md-push-11": "col-md-push-11",
	"col-md-push-10": "col-md-push-10",
	"col-md-push-9": "col-md-push-9",
	"col-md-push-8": "col-md-push-8",
	"col-md-push-7": "col-md-push-7",
	"col-md-push-6": "col-md-push-6",
	"col-md-push-5": "col-md-push-5",
	"col-md-push-4": "col-md-push-4",
	"col-md-push-3": "col-md-push-3",
	"col-md-push-2": "col-md-push-2",
	"col-md-push-1": "col-md-push-1",
	"col-md-push-0": "col-md-push-0",
	"col-md-offset-12": "col-md-offset-12",
	"col-md-offset-11": "col-md-offset-11",
	"col-md-offset-10": "col-md-offset-10",
	"col-md-offset-9": "col-md-offset-9",
	"col-md-offset-8": "col-md-offset-8",
	"col-md-offset-7": "col-md-offset-7",
	"col-md-offset-6": "col-md-offset-6",
	"col-md-offset-5": "col-md-offset-5",
	"col-md-offset-4": "col-md-offset-4",
	"col-md-offset-3": "col-md-offset-3",
	"col-md-offset-2": "col-md-offset-2",
	"col-md-offset-1": "col-md-offset-1",
	"col-md-offset-0": "col-md-offset-0",
	"col-lg-pull-12": "col-lg-pull-12",
	"col-lg-pull-11": "col-lg-pull-11",
	"col-lg-pull-10": "col-lg-pull-10",
	"col-lg-pull-9": "col-lg-pull-9",
	"col-lg-pull-8": "col-lg-pull-8",
	"col-lg-pull-7": "col-lg-pull-7",
	"col-lg-pull-6": "col-lg-pull-6",
	"col-lg-pull-5": "col-lg-pull-5",
	"col-lg-pull-4": "col-lg-pull-4",
	"col-lg-pull-3": "col-lg-pull-3",
	"col-lg-pull-2": "col-lg-pull-2",
	"col-lg-pull-1": "col-lg-pull-1",
	"col-lg-pull-0": "col-lg-pull-0",
	"col-lg-push-12": "col-lg-push-12",
	"col-lg-push-11": "col-lg-push-11",
	"col-lg-push-10": "col-lg-push-10",
	"col-lg-push-9": "col-lg-push-9",
	"col-lg-push-8": "col-lg-push-8",
	"col-lg-push-7": "col-lg-push-7",
	"col-lg-push-6": "col-lg-push-6",
	"col-lg-push-5": "col-lg-push-5",
	"col-lg-push-4": "col-lg-push-4",
	"col-lg-push-3": "col-lg-push-3",
	"col-lg-push-2": "col-lg-push-2",
	"col-lg-push-1": "col-lg-push-1",
	"col-lg-push-0": "col-lg-push-0",
	"col-lg-offset-12": "col-lg-offset-12",
	"col-lg-offset-11": "col-lg-offset-11",
	"col-lg-offset-10": "col-lg-offset-10",
	"col-lg-offset-9": "col-lg-offset-9",
	"col-lg-offset-8": "col-lg-offset-8",
	"col-lg-offset-7": "col-lg-offset-7",
	"col-lg-offset-6": "col-lg-offset-6",
	"col-lg-offset-5": "col-lg-offset-5",
	"col-lg-offset-4": "col-lg-offset-4",
	"col-lg-offset-3": "col-lg-offset-3",
	"col-lg-offset-2": "col-lg-offset-2",
	"col-lg-offset-1": "col-lg-offset-1",
	"col-lg-offset-0": "col-lg-offset-0",
	"table-condensed": "table-condensed",
	"table-striped": "table-striped",
	"table-hover": "table-hover",
	"active": "active",
	"success": "success",
	"info": "info",
	"warning": "warning",
	"danger": "danger",
	"table-responsive": "table-responsive",
	"form-control": "form-control",
	"input-group-sm": "input-group-sm",
	"input-sm": "input-sm",
	"input-group-lg": "input-group-lg",
	"input-lg": "input-lg",
	"form-group": "form-group",
	"checkbox": "checkbox",
	"radio": "radio",
	"checkbox-inline": "checkbox-inline",
	"radio-inline": "radio-inline",
	"disabled": "disabled",
	"form-control-static": "form-control-static",
	"form-group-sm": "form-group-sm",
	"form-group-lg": "form-group-lg",
	"has-feedback": "has-feedback",
	"form-control-feedback": "form-control-feedback",
	"has-success": "has-success",
	"control-label": "control-label",
	"help-block": "help-block",
	"input-group-addon": "input-group-addon",
	"has-warning": "has-warning",
	"has-error": "has-error",
	"form-inline": "form-inline",
	"input-group": "input-group",
	"input-group-btn": "input-group-btn",
	"form-horizontal": "form-horizontal",
	"focus": "focus",
	"btn-default": "btn-default",
	"open": "open",
	"dropdown-toggle": "dropdown-toggle",
	"badge": "badge",
	"btn-primary": "btn-primary",
	"btn-success": "btn-success",
	"btn-info": "btn-info",
	"btn-warning": "btn-warning",
	"btn-danger": "btn-danger",
	"btn-link": "btn-link",
	"btn-group-lg": "btn-group-lg",
	"btn-lg": "btn-lg",
	"btn-group-sm": "btn-group-sm",
	"btn-sm": "btn-sm",
	"btn-group-xs": "btn-group-xs",
	"btn-xs": "btn-xs",
	"btn-block": "btn-block",
	"fade": "fade",
	"in": "in",
	"collapse": "collapse",
	"collapsing": "collapsing",
	"dropdown": "dropdown",
	"dropdown-menu": "dropdown-menu",
	"divider": "divider",
	"dropdown-menu-right": "dropdown-menu-right",
	"dropdown-menu-left": "dropdown-menu-left",
	"dropdown-header": "dropdown-header",
	"dropdown-backdrop": "dropdown-backdrop",
	"navbar-fixed-bottom": "navbar-fixed-bottom",
	"navbar-right": "navbar-right",
	"btn-group": "btn-group",
	"btn-group-vertical": "btn-group-vertical",
	"btn-toolbar": "btn-toolbar",
	"btn-group-justified": "btn-group-justified",
	"nav": "nav",
	"nav-divider": "nav-divider",
	"nav-tabs": "nav-tabs",
	"nav-justified": "nav-justified",
	"nav-pills": "nav-pills",
	"nav-stacked": "nav-stacked",
	"nav-tabs-justified": "nav-tabs-justified",
	"tab-content": "tab-content",
	"tab-pane": "tab-pane",
	"navbar-header": "navbar-header",
	"navbar-collapse": "navbar-collapse",
	"navbar-fixed-top": "navbar-fixed-top",
	"navbar-static-top": "navbar-static-top",
	"navbar-brand": "navbar-brand",
	"navbar-toggle": "navbar-toggle",
	"icon-bar": "icon-bar",
	"navbar-nav": "navbar-nav",
	"navbar-form": "navbar-form",
	"navbar-btn": "navbar-btn",
	"navbar-text": "navbar-text",
	"navbar-left": "navbar-left",
	"navbar-default": "navbar-default",
	"navbar-link": "navbar-link",
	"navbar-inverse": "navbar-inverse",
	"breadcrumb": "breadcrumb",
	"pagination": "pagination",
	"pagination-lg": "pagination-lg",
	"pagination-sm": "pagination-sm",
	"pager": "pager",
	"next": "next",
	"previous": "previous",
	"label-default": "label-default",
	"label-primary": "label-primary",
	"label-success": "label-success",
	"label-info": "label-info",
	"label-warning": "label-warning",
	"label-danger": "label-danger",
	"list-group-item": "list-group-item",
	"jumbotron": "jumbotron",
	"caption": "caption",
	"alert": "alert",
	"alert-link": "alert-link",
	"alert-dismissable": "alert-dismissable",
	"alert-dismissible": "alert-dismissible",
	"close": "close",
	"alert-success": "alert-success",
	"alert-info": "alert-info",
	"alert-warning": "alert-warning",
	"alert-danger": "alert-danger",
	"progress": "progress",
	"progress-bar": "progress-bar",
	"progress-bar-striped": "progress-bar-striped",
	"progress-striped": "progress-striped",
	"progress-bar-stripes": "progress-bar-stripes",
	"progress-bar-success": "progress-bar-success",
	"progress-bar-info": "progress-bar-info",
	"progress-bar-warning": "progress-bar-warning",
	"progress-bar-danger": "progress-bar-danger",
	"media": "media",
	"media-body": "media-body",
	"media-object": "media-object",
	"media-right": "media-right",
	"media-left": "media-left",
	"pull-left": "pull-left",
	"media-middle": "media-middle",
	"media-bottom": "media-bottom",
	"media-heading": "media-heading",
	"media-list": "media-list",
	"list-group": "list-group",
	"list-group-item-heading": "list-group-item-heading",
	"list-group-item-text": "list-group-item-text",
	"list-group-item-success": "list-group-item-success",
	"list-group-item-info": "list-group-item-info",
	"list-group-item-warning": "list-group-item-warning",
	"list-group-item-danger": "list-group-item-danger",
	"panel": "panel",
	"panel-body": "panel-body",
	"panel-heading": "panel-heading",
	"panel-title": "panel-title",
	"panel-footer": "panel-footer",
	"panel-collapse": "panel-collapse",
	"panel-group": "panel-group",
	"panel-default": "panel-default",
	"panel-primary": "panel-primary",
	"panel-success": "panel-success",
	"panel-info": "panel-info",
	"panel-warning": "panel-warning",
	"panel-danger": "panel-danger",
	"embed-responsive": "embed-responsive",
	"embed-responsive-item": "embed-responsive-item",
	"embed-responsive-16by9": "embed-responsive-16by9",
	"embed-responsive-4by3": "embed-responsive-4by3",
	"well": "well",
	"well-lg": "well-lg",
	"well-sm": "well-sm",
	"modal-open": "modal-open",
	"modal": "modal",
	"modal-dialog": "modal-dialog",
	"modal-content": "modal-content",
	"modal-backdrop": "modal-backdrop",
	"modal-header": "modal-header",
	"modal-title": "modal-title",
	"modal-body": "modal-body",
	"modal-footer": "modal-footer",
	"modal-scrollbar-measure": "modal-scrollbar-measure",
	"modal-sm": "modal-sm",
	"modal-lg": "modal-lg",
	"tooltip": "tooltip",
	"top": "top",
	"right": "right",
	"bottom": "bottom",
	"left": "left",
	"tooltip-inner": "tooltip-inner",
	"tooltip-arrow": "tooltip-arrow",
	"top-left": "top-left",
	"top-right": "top-right",
	"bottom-left": "bottom-left",
	"bottom-right": "bottom-right",
	"popover": "popover",
	"popover-title": "popover-title",
	"popover-content": "popover-content",
	"arrow": "arrow",
	"carousel": "carousel",
	"prev": "prev",
	"carousel-control": "carousel-control",
	"icon-next": "icon-next",
	"icon-prev": "icon-prev",
	"carousel-indicators": "carousel-indicators",
	"carousel-caption": "carousel-caption",
	"clearfix": "clearfix",
	"center-block": "center-block",
	"hide": "hide",
	"show": "show",
	"invisible": "invisible",
	"text-hide": "text-hide",
	"hidden": "hidden",
	"affix": "affix",
	"visible-lg": "visible-lg",
	"visible-md": "visible-md",
	"visible-sm": "visible-sm",
	"visible-xs": "visible-xs",
	"visible-lg-block": "visible-lg-block",
	"visible-lg-inline": "visible-lg-inline",
	"visible-lg-inline-block": "visible-lg-inline-block",
	"visible-md-block": "visible-md-block",
	"visible-md-inline": "visible-md-inline",
	"visible-md-inline-block": "visible-md-inline-block",
	"visible-sm-block": "visible-sm-block",
	"visible-sm-inline": "visible-sm-inline",
	"visible-sm-inline-block": "visible-sm-inline-block",
	"visible-xs-block": "visible-xs-block",
	"visible-xs-inline": "visible-xs-inline",
	"visible-xs-inline-block": "visible-xs-inline-block",
	"hidden-xs": "hidden-xs",
	"hidden-sm": "hidden-sm",
	"hidden-md": "hidden-md",
	"hidden-lg": "hidden-lg",
	"visible-print": "visible-print",
	"visible-print-block": "visible-print-block",
	"visible-print-inline": "visible-print-inline",
	"visible-print-inline-block": "visible-print-inline-block",
	"hidden-print": "hidden-print",
	"app": "app",
	"root-container": "root-container",
	"content": "content",
	"teal": "teal",
	"purple": "purple",
	"orange": "orange",
	"top-nav": "top-nav",
	"dropdonw-toggle": "dropdonw-toggle",
	"btn-teal": "btn-teal",
	"btn--small": "btn--small"
};

/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "448c34a5.woff2";

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "fa277232.woff";

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e18bbf61.ttf";

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "89889688.svg";

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(699);
    var insertCss = __webpack_require__(33);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./Header.scss", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./Header.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ba8b5434.svg";

/***/ }),

/***/ 740:
/***/ (function(module, exports) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"intl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"defaultValue":null}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"intl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":null,"name":{"kind":"Name","value":"id"},"arguments":[],"directives":[],"selectionSet":null},{"kind":"Field","alias":null,"name":{"kind":"Name","value":"message"},"arguments":[],"directives":[],"selectionSet":null}]}}]}}],"loc":{"start":0,"end":82}};
    doc.loc.source = {"body":"query intl ($locale:String!) {\n  intl (locale:$locale) {\n    id\n    message\n  }\n}\n","name":"GraphQL request"};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  
module.exports = doc;

/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(742);
    var insertCss = __webpack_require__(33);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./LanguageSwitcher.scss", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./LanguageSwitcher.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)(false);
// imports


// module
exports.push([module.i, "._1eAX_{padding-top:5px;border-top:1px solid #e6e6e6}._1eAX_>span{padding:10px 25px;text-align:left;text-transform:uppercase}._1eAX_>span a{color:#00dcb2}._1eAX_>span:first-child{padding-right:5px}._1eAX_>span:last-child{padding:10px}", ""]);

// exports
exports.locals = {
	"languageSwitcher": "_1eAX_"
};

/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(750);
    var insertCss = __webpack_require__(33);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./Footer.scss", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./Footer.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)(false);
// imports


// module
exports.push([module.i, "._2nhzB{height:271px;color:#fff;background:#646464}@media (max-width:480px){._2nhzB{height:auto}}._2bFCd{margin:0 auto;padding:25px 15px;max-width:1000px;text-align:center}._2bFCd h4{color:#fff;font-size:19.2px;font-size:1.2rem;text-transform:uppercase}._2bFCd ul{padding-left:0;list-style-type:none}._2bFCd ul li{margin:2px 0}._2bFCd a,._2bFCd a:active,._2bFCd a:focus,._2bFCd a:hover{color:#fff}._2bFCd ._3UIM1{margin-top:25px}._2bFCd ._3UIM1 a{display:inline-block;width:24px;width:1.5rem;height:24px;height:1.5rem;margin:0 5px;color:#646464;background:#fff;border-radius:50%}._2bFCd ._3UIM1 a:active,._2bFCd ._3UIM1 a:focus,._2bFCd ._3UIM1 a:hover{text-decoration:none}", ""]);

// exports
exports.locals = {
	"footer": "_2nhzB",
	"content": "_2bFCd",
	"socialMediaLinks": "_3UIM1"
};

/***/ }),

/***/ 751:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(752);
    var insertCss = __webpack_require__(33);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./Sidebar.scss", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./Sidebar.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 752:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)(false);
// imports


// module
exports.push([module.i, "._3X-DF{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:fixed;top:0;right:0;width:25px;height:100%;padding:0 25px;z-index:10}._3X-DF span{-webkit-box-flex:1;-ms-flex:1 1 0%;flex:1 1 0%;padding-left:240px;padding-left:15rem;color:#00dcb2;font-size:19.2px;font-size:1.2rem;-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg);white-space:nowrap}", ""]);

// exports
exports.locals = {
	"sidebar": "_3X-DF"
};

/***/ }),

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(754);
    var insertCss = __webpack_require__(33);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../../node_modules/sass-loader/lib/loader.js!./Products.scss", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../../node_modules/sass-loader/lib/loader.js!./Products.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 754:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)(false);
// imports


// module
exports.push([module.i, "._7jLBY{margin:25px 0 50px}._7jLBY ._3xQY0{margin:25px 0;text-align:center}._7jLBY ._3xQY0 img{margin:0 auto 35px}._7jLBY ._3xQY0 h3{margin:0;font-family:Gotham Rounded A,Gotham Rounded B,HelveticaNeue-light,Arial,sans-serif;font-style:normal;font-weight:400;font-size:24px;font-size:1.5rem}._7jLBY ._3xQY0 h4{margin-top:35px;margin-bottom:5px;font-family:Gotham SSm A,Gotham SSm B,HelveticaNeue-light,Arial,sans-serif;font-style:normal;font-weight:700}._7jLBY ._3xQY0 p{margin-bottom:15px}", ""]);

// exports
exports.locals = {
	"products": "_7jLBY",
	"product": "_3xQY0"
};

/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(756);
    var insertCss = __webpack_require__(33);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../../node_modules/sass-loader/lib/loader.js!./Customers.scss", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../../node_modules/sass-loader/lib/loader.js!./Customers.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 756:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)(false);
// imports


// module
exports.push([module.i, ".P3oL2{margin:0 -50px;padding:15px 50px 50px;background:rgba(0,220,178,.2)}@media (max-width:480px){.P3oL2{margin:0 -40px}}.lplJ4{display:block;margin-top:25px}.lplJ4 ._2QTm3{position:relative;height:293px;margin-bottom:15px;background:#fff;background-clip:content-box}.lplJ4 ._2QTm3>div{position:absolute;bottom:15px;padding:50px 15px 15px}.lplJ4 ._2QTm3 p>span{font-family:Gotham SSm A,Gotham SSm B,HelveticaNeue-light,sans-serif;font-style:normal;font-weight:500;color:#00dcb2;font-size:25.6px;font-size:1.6rem;line-height:30.4px;line-height:1.9rem}.lplJ4 ._2QTm3 span{color:#646464;font-size:12.8px;font-size:.8rem}.lplJ4 ._1nMUo{background:#00dcb2;background-clip:content-box}.lplJ4 ._1nMUo p>span{color:#fff}.vD6-q{display:block;margin:25px auto;padding:0 0 150px;text-align:center}.vD6-q a,.vD6-q a:active,.vD6-q a:focus{display:inline-block;margin:15px}@media (max-width:480px){.vD6-q a,.vD6-q a:active,.vD6-q a:focus{width:90%}}.vD6-q a:active img,.vD6-q a:focus img,.vD6-q a img{height:33px;filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0\" /></filter></svg>#filter');-webkit-filter:grayscale(1);filter:grayscale(1)}.vD6-q a:hover img{-webkit-filter:none;filter:none}", ""]);

// exports
exports.locals = {
	"container": "P3oL2",
	"testimonials": "lplJ4",
	"testimonial": "_2QTm3",
	"testimonialInverse": "_1nMUo",
	"partners": "vD6-q"
};

/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b67fa079.jpg";

/***/ }),

/***/ 758:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f54cd9ab.jpg";

/***/ }),

/***/ 759:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "273d8c5e.jpg";

/***/ }),

/***/ 760:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c4d4b2ff.jpg";

/***/ }),

/***/ 761:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "70cd20ba.png";

/***/ }),

/***/ 762:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ca9062e9.jpg";

/***/ }),

/***/ 763:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "428b153b.jpg";

/***/ }),

/***/ 764:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "e48c1e3d.svg";

/***/ }),

/***/ 765:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "20bd03d9.svg";

/***/ }),

/***/ 766:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "08933d91.svg";

/***/ }),

/***/ 767:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "b6ee7e4a.svg";

/***/ }),

/***/ 768:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "34ee47e7.svg";

/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "d115470b.svg";

/***/ }),

/***/ 772:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)(false);
// imports


// module
exports.push([module.i, "._2GMnf{-webkit-box-shadow:none;box-shadow:none}._2GMnf,._3x2Nt{background:none;border:0}._5wvcj{padding:0;border:0}._1nsHR,._1nsHR:active,._1nsHR:focus,._1nsHR:hover{width:100%;color:#646464;font-size:16px;font-size:1rem;background:none;-webkit-box-shadow:none;box-shadow:none;white-space:normal;border:1px solid #a9a9a9}._31Gym [class^=panel]>div button{margin-top:0}", ""]);

// exports
exports.locals = {
	"panel": "_2GMnf",
	"panelHeading": "_3x2Nt",
	"panelBody": "_5wvcj",
	"toggleButton": "_1nsHR",
	"collapsibleDetails": "_31Gym"
};

/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(774);
    var insertCss = __webpack_require__(33);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../../node_modules/sass-loader/lib/loader.js!./Features.scss", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../../node_modules/sass-loader/lib/loader.js!./Features.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 774:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)(false);
// imports


// module
exports.push([module.i, "._2LpEv{margin-top:30px;padding-left:0;list-style-type:none;text-align:center}._2LpEv li{position:relative;padding-left:30px;text-align:left}._2LpEv li i:first-child{position:absolute;left:0}@media (max-width:480px){._2LpEv{margin:0 -30px;padding:15px;background:#afddb6}}._2LpEv li{margin:20px 0;font-size:.9em}", ""]);

// exports
exports.locals = {
	"licenseBenefits": "_2LpEv"
};

/***/ }),

/***/ 775:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(776);
    var insertCss = __webpack_require__(33);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../../node_modules/sass-loader/lib/loader.js!./Pricing.scss", function() {
        content = require("!!../../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../../node_modules/sass-loader/lib/loader.js!./Pricing.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 776:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)(false);
// imports


// module
exports.push([module.i, "._1YdxG{margin-top:60px}._1YdxG h3{margin:0 0 10px}._3OiK7{padding:15px 50px;margin-bottom:25px;text-align:center;background:#ccf8ef}@media (max-width:992px){._3OiK7{padding:20px}}@media (max-width:480px){._3OiK7{padding:15px;background:#fff}}._3OiK7 h3{margin:0;font-family:Gotham Rounded A,Gotham Rounded B,HelveticaNeue-light,Arial,sans-serif;font-style:normal;font-weight:400;font-size:24px;font-size:1.5rem}._3OiK7 h4{margin-top:35px;margin-bottom:5px;font-family:Gotham SSm A,Gotham SSm B,HelveticaNeue-light,Arial,sans-serif;font-style:normal;font-weight:700}._3OiK7 ._3ICLL{text-align:center}._3OiK7 ._3ICLL h1{color:#000}._3G93m{width:100%}@media only screen and (min-width:768px){._3G93m{display:table}}@media only screen and (max-width:767px){._3G93m{margin-top:40px}}@media only screen and (min-width:768px){._3G93m>div{display:table-cell;vertical-align:top;float:none}}@media (max-width:992px){._3G93m>div{font-size:.9rem}._3G93m>div a{font-size:.9em}}@media (max-width:790px){._3G93m>div{font-size:.8rem}}@media (max-width:768px){._3G93m>div{margin-bottom:10px}}@media (max-width:480px){._3G93m>div{padding-top:25px;padding-bottom:15px;border-top:1px solid #e6e6e6}._3G93m>div,._3G93m>div a{font-size:inherit}}._3G93m>div button{margin-top:20px}._3G93m>div:last-child{border-right:0}._2cuXz{display:block;margin:0 auto}._2cuXz h2{font-size:48px;font-size:3rem;color:#646464;padding-bottom:15px}._2cuXz h2 sup{position:relative;top:-.7em;left:-.5em;color:#7a7a7a;font-size:.55em}._2cuXz>span{display:block;margin:0 auto 20px;line-height:1.2em}", ""]);

// exports
exports.locals = {
	"pricingContainer": "_1YdxG",
	"pricingContentContainer": "_3OiK7",
	"content": "_3ICLL",
	"licenses": "_3G93m",
	"price": "_2cuXz"
};

/***/ }),

/***/ 777:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(778);
    var insertCss = __webpack_require__(33);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./ProductPage.scss", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./ProductPage.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 778:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)(false);
// imports


// module
exports.push([module.i, "._3Efp2{position:relative;margin:0 auto;padding:0 15px;max-width:1000px}._3Efp2 h1,._3Efp2 h2,._3Efp2 h3{margin:0;text-align:center}._3Efp2 h2{margin-bottom:0}._3Efp2 h3{margin-top:10px}._2xiAG{width:100%}.dtkyD{height:80px}@media (max-width:992px){.dtkyD{height:60px}}@media (max-width:480px){.dtkyD{height:40px}}.Z_Feq{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:20px}@media (max-width:992px){.Z_Feq h1{font-size:30px}}@media (max-width:480px){.Z_Feq h1{font-size:24px}}.Z_Feq img{margin-right:15px}.UngbK{margin-bottom:40px}@media (max-width:992px){.UngbK h2{font-size:18px}}@media (max-width:480px){.UngbK h2{font-size:16px}}", ""]);

// exports
exports.locals = {
	"container": "_3Efp2",
	"headerImg": "_2xiAG",
	"logoImg": "dtkyD",
	"header": "Z_Feq",
	"subline": "UngbK"
};

/***/ }),

/***/ 779:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(780);
    var insertCss = __webpack_require__(33);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./NotFound.scss", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--2-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--2-rules-4!../../../node_modules/sass-loader/lib/loader.js!./NotFound.scss");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 780:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(32)(false);
// imports


// module
exports.push([module.i, "._1g2_9{padding-left:20px;padding-right:20px}._3n8Tt{margin:0 auto;padding:0 0 40px;max-width:1000px}", ""]);

// exports
exports.locals = {
	"root": "_1g2_9",
	"container": "_3n8Tt"
};

/***/ })

},[318]);


// WEBPACK FOOTER //
// client.46309668.js